/* eslint-disable react/jsx-no-bind */
import * as color from "../../constants/color";
import * as routeHelpers from "../../lib/routeHelpers";
import * as searchInputTypes from "../../constants/searchInputTypes";
import { StyleSheet, css } from "aphrodite";
import Spinner from "../Spinner";
import TextInput from "../inputs/TextInput";
import PageTitle from "../text/PageTitle";
import TextArea from "../inputs/TextArea";
import FileBrowser from "../inputs/FileBrowser";
import Dropzone from "react-dropzone";
import Checkbox from "../inputs/Checkbox";
import Toggle from "../inputs/Toggle";
import React, { Component } from "react";
import AddButton from "../AddButton";
import ActionButton from "../ActionButton";
import Modal from "../Modal";
import { connect } from "react-redux";
import * as texchangePropTypes from "../../texchangePropTypes";
import logger from "../../lib/logger";
import InlineEdit from "../inputs/InlineEdit";
import Headline from "../text/Headline";
import { Container, Row, Column } from "../grid";
import SearchInput from "../inputs/SearchInput";
import Dropdown from "../inputs/Dropdown";
import SmallDropdown from "../inputs/SmallDropdown";
import { ReactComponent as GarbageIcon } from "../../images/SVGs/garbage.svg";
import { ReactComponent as CancelIcon } from "../../images/SVGs/close.svg";
import plusIcon from "../../images/SVGs/plusIcon.svg";
import DatePicker from "../inputs/DatePicker";
import DatePicker2 from "../inputs/DatePicker2";
import Tabs from "../Tabs";
import Infinite from "../Infinite";
import * as employerApi from "../../lib/api/employer";
import * as censusApi from "../../lib/api/census";
import * as dataApi from "../../lib/api/data";
import * as searchApi from "../../lib/api/search";
import * as util from "../../lib/util";
import segmentSizes from "../../constants/segmentSizes";
import format from "date-fns/format";
import sortBy from "lodash.sortby";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import searchIcon from "../../images/SVGs/SearchStreamline.svg";

const styles = StyleSheet.create({
    content: {
        paddingRight: 10,
        paddingBottom: 80,
        ":after": {
            content: '""',
            display: "table",
            clear: "both",
        },
    },
    contentSection: {
        width: "100%",
        padding: 0,
        backgroundColor: color.white,
        borderTop: `8px solid ${color.mediumRed}`,
        marginBottom: 0,
    },
    title: {
        fontSize: 20,
        fontWeight: 500,
        paddingBottom: 0,
        marginBottom: 16,
    },
    titleSection: {
        heigth: 64,
    },
    groupDetails: {
        marginBottom: 20,
    },
    generalInfo: {
        padding: 24,
        paddingBottom: 64,
        backgroundColor: color.white,
    },
    tabContentHeader: {
        padding: 24,
        backgroundColor: color.white,
    },
    tabContentHeaderText: {
        color: color.darkestGray,
        fontWeight: 500,
        fontSize: 20,
    },
    leftColumn: {
        paddingRight: 16,
    },
    centerColumn: {
        paddingRight: 16,
        paddingLeft: 16,
    },
    rightColumn: {
        paddingLeft: 16,
    },
    checkboxContainer: {
        textAlign: "right",
        marginTop: 12,
        marginBottom: 12,
    },
    checkLabel: {
        display: "inline-block",
        position: "relative",
        border: "none",
        marginTop: 8,
        marginBottom: 10,
        "-webkit-appearance": "none",
        cursor: "pointer",
        ":first-child": {
            marginRight: 24,
        },
    },
    check: {
        position: "absolute",
        top: -2,
        left: 0,
        marginRight: 10,
    },
    labelText: {
        marginLeft: 28,
        fontSize: 14,
        marginRight: 12,
    },
    container: {
        borderBottom: `1px solid ${color.darkGray6}`,
        paddingBottom: 12,
        marginBottom: 12,
        height: 60,
    },
    containerScroll: {
        borderBottom: `1px solid ${color.darkGray6}`,
        paddingBottom: 12,
        marginBottom: 12,
        height: 109,
        overflowX: "scroll",
    },
    headerLabel: {
        float: "left",
        fontSize: 14,
        fontWeight: 500,
        color: color.darkGray,
    },
    displayContainer: {
        clear: "both",
        color: color.darkestGray,
        fontSize: 16,
        paddingTop: 10,
    },
    displayRow: {
        marginTop: 6,
        marginBottom: 6,
        minHeight: 18,
    },
    countyHelpText: {
        marginTop: 4,
        marginBottom: 2,
        fontSize: 12,
        color: color.darkGray,
    },
    dependentStatusContainer: {
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    dependentStatusLabel: {
        fontSize: 14,
        color: color.tableText,
        lineHeight: "16px",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
    link: {
        cursor: "pointer",
        color: color.mediumYellow1,
    },
    dropdownEdit: {
        paddingTop: 10,
    },
    asOf: {
        fontSize: 14,
        position: "relative",
        left: 6,
        top: -2,
    },
    quotesByYearHeader: {
        display: "flex",
    },
    quotesByYearText: {
        color: color.darkestGray,
        fontWeight: 500,
        fontSize: 20,
        marginRight: 10,
    },
    quotesByYearDropdown: {
        width: 110,
    },
    censusDropdown: {
        width: 400,
        marginTop: -8,
    },
    censusButtonsHeader: {
        justifyContent: "flex-end",
    },
    columnFilterContainer2: {
        display: "flex",
        justifyContent: "flex-start",
    },
    resetButtonHolder: {
        marginTop: 12,
    },
    worksheetButton: {
        float: "none",
        cursor: "pointer",
        padding: 5,
        marginTop: 0,
        marginRight: 0,
        border: `1px solid ${color.darkGray7}`,
        borderRadius: 4,
    },
    countyRequiredMessage: {
        marginTop: 12,
        color: color.darkRed,
        fontSize: 14,
        fontWeight: 500,
    },
    table: {
        width: "100%",
        marginTop: 5,
        marginBottom: 10,
        borderCollapse: "collapse",
    },
    tableFirstColumn: {
        paddingLeft: 16,
    },
    tableHeader: {
        fontSize: 12,
        color: color.mediumYellow1,
        fontWeight: 500,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 12,
        paddingBottom: 12,
        whiteSpace: "nowrap",
        borderBottom: `1px solid ${color.mediumGray}`,
        borderTop: `1px solid ${color.darkGray2}`,
        backgroundColor: color.white,
    },
    tableRow: {
        fontSize: 14,
        color: color.tableText,
        padding: "8px 6px",
        borderBottom: `1px solid ${color.tableBorder}`,
    },
    tableRowWide: {
        width: 380,
    },
    tableCheckboxCell: {
        textAlign: "center",
        width: 48,
    },
    tablePlanFlagCell: {
        textAlign: "center",
        width: 58,
        minWidth: 58,
        maxWidth: 58,
        padding: "8px 0",
    },
    tablePlanFlagHeaderCell: {
        textAlign: "center",
        width: 58,
        minWidth: 58,
        maxWidth: 58,
    },
    planFlagCheckLabel: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        border: "none",
        marginTop: 0,
        marginBottom: 0,
        width: 16,
        height: 16,
        "-webkit-appearance": "none",
        cursor: "pointer",
    },
    planFlagCheck: {
        position: "static",
        top: "auto",
        left: "auto",
        marginRight: 0,
    },
    redBar: {
        borderLeft: `4px solid ${color.mediumRed}`,
    },
    blueBar: {
        borderLeft: `4px solid ${color.borderBackgroundGray}`,
    },
    noResults: {
        backgroundColor: color.white,
        color: color.darkGray,
        padding: 20,
        marginBottom: 40,
    },
    right: {
        float: "right",
        position: "relative",
        top: -38,
        right: 20,
        fontSize: 14,
        color: color.tableText,
    },
    addButton: {
        float: "right",
        cursor: "pointer",
        padding: 5,
        marginTop: 13,
        marginRight: 24,
        border: `1px solid ${color.darkGray7}`,
        borderRadius: 4,
    },
    addButtonSpinner: {
        float: "right",
        padding: 5,
        marginTop: 13,
        marginRight: 44,
    },
    modalContent: {
        width: 386,
    },
    modalInstructions: {
        color: color.darkestGray,
        fontSize: 16,
        marginTop: 20,
        marginBottom: 8,
    },
    modalButtonContainer: {
        marginTop: 24,
        display: "flex",
        justifyContent: "space-between",
    },
    modalButton: {
        width: 150,
    },
    icon: {
        cursor: "pointer",
    },
    loadingSpinner: {
        paddingTop: 48,
        paddingBottom: 48,
    },
    censusTableCellLink: {
        fontSize: 14,
        fontWeight: "bold",
        color: color.mediumYellow1,
        textDecoration: "underline",
        cursor: "pointer",
    },
    censusTableCellCenter: {
        textAlign: "center",
    },
    censusTableCellRight: {
        textAlign: "right",
        paddingRight: 20,
    },
    censusButton: {
        clear: "both",
        borderRadius: 8,
    },
    loadCensusButton: {
        border: `1px dashed ${color.mediumYellow1}`,
        padding: "39px 24px",
        color: color.darkGray,
    },
    censusSelectedButtonText: {
        color: color.darkRed,
        marginTop: 4,
        fontSize: 16,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "inline-block",
        maxWidth: 180,
    },
    censusFileSelected: {
        border: `1px dashed ${color.mediumRed}`,
    },
    censusButtonText: {
        fontSize: 20,
    },
    clearCensusButton: {
        display: "inline-block",
        float: "right",
        cursor: "pointer",
    },
    worksheetFieldsRow: {
        display: "flex",
        gap: 12,
        alignItems: "flex-start",
        marginBottom: 16,
    },
    worksheetField: {
        flex: 1,
    },
    worksheetLabel: {
        color: color.darkestGray,
        fontSize: 14,
        fontWeight: 500,
        marginBottom: 8,
    },
    worksheetRequiredLabel: {
        color: color.darkRed,
    },
    worksheetModalContent: {
        width: "100%",
    },
    worksheetModalContainer: {
        width: "80%",
        maxWidth: "95%",
        minHeight: 450,
    },
    worksheetModalBody: {
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        padding: "20px 24px",
        boxSizing: "border-box",
    },
    worksheetSectionTitle: {
        color: color.darkestGray,
        fontSize: 42,
        fontWeight: 500,
        marginBottom: 12,
    },
    worksheetControlRow: {
        marginBottom: 12,
    },
    worksheetPlansRow: {
        display: "flex",
        alignItems: "stretch",
        gap: 20,
        marginBottom: 24,
    },
    worksheetListColumn: {
        flex: 1,
    },
    worksheetListHeader: {
        border: `1px solid ${color.mediumGray}`,
        borderBottom: 0,
        padding: "10px 14px",
        color: color.darkestGray,
        fontSize: 14,
        fontWeight: 500,
        backgroundColor: color.darkGray2,
    },
    worksheetListHeaderWithIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    worksheetListHeaderIcon: {
        width: 14,
        height: 14,
        opacity: 0.8,
    },
    worksheetListHeaderIconButton: {
        border: 0,
        background: "transparent",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
    },
    worksheetListFilterInput: {
        marginTop: "0 !important",
    },
    worksheetListBody: {
        border: `1px solid ${color.mediumGray}`,
        height: 210,
        overflowY: "auto",
        backgroundColor: color.white,
    },
    worksheetPlanItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
        padding: "10px 12px",
        borderBottom: `1px solid ${color.darkGray6}`,
    },
    worksheetPlanItemName: {
        color: color.darkestGray,
        fontSize: 14,
    },
    worksheetPlanMoveButton: {
        border: 0,
        background: "transparent",
        cursor: "pointer",
        color: color.darkestGray,
        fontSize: 16,
        lineHeight: 1,
        padding: 0,
        minWidth: 16,
    },
    worksheetPlanRemoveButton: {
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: 0,
        minWidth: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    worksheetPlanRemoveIcon: {
        width: 14,
        height: 14,
    },
    worksheetListEmptyText: {
        color: color.darkGray,
        fontSize: 14,
        padding: "10px 12px",
    },
    worksheetListActions: {
        width: 28,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 16,
    },
    worksheetListActionButton: {
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputAppendLabel: {
        padding: "24px 30px 12px 160px !important",
    },
    worksheetContributionRow: {
        display: "flex",
        gap: 16,
        marginBottom: 16,
    },
    worksheetCheckboxRow: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 16,
    },
    worksheetCheckboxLabel: {
        color: color.darkestGray,
        fontSize: 14,
        fontWeight: 500,
        cursor: "pointer",
    },
    worksheetContributionCol: {
        flex: 1,
    },
    worksheetContributionHeader: {
        color: color.darkestGray,
        fontSize: 14,
        fontWeight: 500,
        marginBottom: 8,
    },
    worksheetAmountHeaderRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: -10,
    },
    worksheetAmountToggleInline: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    worksheetAmountControls: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    worksheetSymbol: {
        color: color.darkestGray,
        fontSize: 20,
        fontWeight: 600,
        marginTop: 4,
    },
    worksheetAmountField: {
        width: "50%",
    },
    worksheetToggle: {
        marginTop: 2,
    },
    worksheetModalButtonRow: {
        marginTop: 20,
        display: "flex",
        justifyContent: "flex-end",
        gap: 12,
    },
    worksheetDisclaimerText: {
        marginTop: 16,
        color: color.darkGray,
        fontSize: 15,
        fontStyle: "italic",
    },
    planFlagHeader: {
        paddingLeft: 4,
        paddingRight: 4,
        minWidth: 56,
    },
    planHeaderLabel: {
        marginBottom: "4px",
        textAlign: "center",
        fontWeight: 500,
    },
    planHeaderLinks: {
        fontSize: "12px",
        display: "inline-block",
        padding: "0 2px",
        lineHeight: "14px",
        textAlign: "center",
        whiteSpace: "nowrap",
    },
    planHeaderLink: {
        color: color.mediumYellow1,
        cursor: "pointer",
        textDecoration: "underline",
    },
});

const strings = {
    generalInformation: "General Information",
    salesAndService: "Sales & Service",
    details: "Details",
    isVirgin: "Virgin group",
    isTest: "Test group",
    groupNameLabel: "Group Name",
    groupNamePlaceholder: "Group Name",
    groupContactLabel: "Group Contact",
    addressLabel: "Address",
    contactNamePlaceholder: "Group Contact Name (First, Last)",
    phonePlaceholder: "Group Contact Phone #",
    statePlaceholder: "State",
    streetAddressPlaceholder: "Street Address",
    cityPlaceholder: "City",
    zipPlaceholder: "Zip",
    countyPlaceholder: "County",
    countyHelpText: "This ZIP maps to multiple counties. Please choose the correct county.",
    sicPlaceholder: "SIC",
    sicLabel: "SIC",
    segmentSizeLabel: "Segment Size",
    segmentSizePlaceholder: "Segment Size",
    payrollCycleLabel: "Pay Period",
    payrollCyclePlaceholder: "Pay Period Frequency",
    brokerLabel: "Broker",
    salesRepresentativeLabel: "Coded Sales Representative",
    specialSalesRepresentativeLabel: "Special Sales Representative",
    renewalRepresentativeLabel: "Renewal Representative",
    salesRepresentativePlaceholder: "Select Coded Sales Representative",
    specialSalesRepresentativePlaceholder: "Select Special Sales Representative",
    renewalRepresentativePlaceholder: "Select Renewal Representative",
    brokerNamePlaceholder: "Enter Broker Name",
    medicalRenewalDateLabel: "Renewal Date",
    medicalRenewalDatePlaceholder: "Enter Renewal Date",
    medicalEffectiveDateLabel: "Sold Plan Effective Date",
    medicalEffectiveDatePlaceholder: "Enter Sold Plan Effective Date",
    existingClientLabel: "Existing Client",
    cobraStatusLabel: "COBRA Status",
    medicalLabel: "Medical Carrier",
    dentalLabel: "Dental Carrier",
    visionLabel: "Vision Carrier",
    lifeLabel: "Life Carrier",
    quotesTabLabel: "Quotes",
    generalInfoTabLabel: "General Info",
    censusTabLabel: "Census",
    notesTabLabel: "Notes",
    groupHistoryTabLabel: "Group History",
    censusInformationText: "Census Information",
    quotesByYearText: "Quotes by year (Eff Date): ",
    medicalPriorCarrierPlaceholder: "Medical Carrier",
    dentalPriorCarrierPlaceholder: "Dental Carrier",
    visionPriorCarrierPlaceholder: "Vision Carrier",
    lifePriorCarrierPlaceholder: "Life Carrier",
    isExistingClientPlaceholder: "Existing Client",
    isCobraPlaceholder: "COBRA Status",
    alias: "Group Aliases",
    currentMedicalPlans: "Current Medical Plan(s)",
};

const inputNames = {
    isVirgin: "isVirgin",
    isTest: "isTest",
    name: "name",
    contactName: "contactName",
    phone: "phone",
    stateId: "stateId",
    street1: "street1",
    street2: "street2",
    city: "city",
    postalCode: "postalCode",
    countyId: "countyId",
    sicCodeId: "sicCodeId",
    segmentSize: "segmentSize",
    salesRepresentativeId: "salesRepresentativeId",
    specialSalesRepresentativeId: "specialSalesRepresentativeId",
    renewalRepresentativeId: "renewalRepresentativeId",
    payrollCycleId: "payrollCycleId",
    brokerId: "brokerId",
    medicalRenewalDate: "medicalRenewalDate",
    medicalEffectiveDate: "medicalEffectiveDate",
    medicalPriorCarrier: "medicalPriorCarrier",
    dentalPriorCarrier: "dentalPriorCarrier",
    visionPriorCarrier: "visionPriorCarrier",
    lifePriorCarrier: "lifePriorCarrier",
    isExistingClient: "isExistingClient",
    isCobra: "isCobra",
    note: "note",
    alias: "alias",
    relationship: "relationship",
    firstName: "firstName",
    lastName: "lastName",
    dob: "dob",
    gender: "gender",
    medicalCoverage: "medicalCoverage",
    dentalCoverage: "dentalCoverage",
    visionCoverage: "visionCoverage",
    lifeCoverage: "lifeCoverage",
    homePostalCode: "homePostalCode",
    workPostalCode: "workPostalCode",
    occupation: "occupation",
    salary: "salary",
    enrollmentDate: "enrollmentDate",
    isPPO: "isPPO",
    isHMO: "isHMO",
    isTobacco: "isTobacco",
    onCobra: "onCobra",
    childDependentStatus: "childDependentStatus",
};

const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

const ENABLE_DEPENDENT_ZIP_EDIT = false;

export class GroupDetailScreen extends Component {
    static propTypes = {
        history: texchangePropTypes.history.isRequired,
        match: texchangePropTypes.match.isRequired,
        me: texchangePropTypes.me.isRequired,
    };

    censusBottomRef = React.createRef();

    state = {
        inputs: {
            [inputNames.name]: "",
            [inputNames.isVirgin]: false,
            [inputNames.isTest]: false,
            [inputNames.contactName]: "",
            [inputNames.phone]: "",
            [inputNames.street1]: "",
            [inputNames.street2]: "",
            [inputNames.city]: "",
            [inputNames.stateId]: "",
            [inputNames.postalCode]: "",
            [inputNames.vericredFipsCode]: "",
            [inputNames.countyId]: null,
            [inputNames.sicCodeId]: "",
            [inputNames.segmentSize]: "",
            [inputNames.salesRepresentativeId]: null,
            [inputNames.specialSalesRepresentativeId]: null,
            [inputNames.renewalRepresentativeId]: null,
            [inputNames.payrollCycleId]: "",
            [inputNames.brokerId]: null,
            [inputNames.medicalRenewalDate]: null,
            [inputNames.medicalEffectiveDate]: null,
            [inputNames.medicalPriorCarrier]: "",
            [inputNames.dentalPriorCarrier]: "",
            [inputNames.visionPriorCarrier]: "",
            [inputNames.lifePriorCarrier]: "",
            [inputNames.isExistingClient]: false,
            [inputNames.isCobra]: false,
            [inputNames.note]: "",
            [inputNames.alias]: "",
            [inputNames.relationship]: "",
            [inputNames.firstName]: "",
            [inputNames.lastName]: "",
            [inputNames.dob]: "",
            [inputNames.gender]: "",
            [inputNames.medicalCoverage]: "",
            [inputNames.dentalCoverage]: "",
            [inputNames.visionCoverage]: "",
            [inputNames.lifeCoverage]: "",
            [inputNames.homePostalCode]: "",
            [inputNames.workPostalCode]: "",
            [inputNames.occupation]: "",
            [inputNames.salary]: "",
            [inputNames.isTobacco]: "",
            [inputNames.onCobra]: "",
        },
        relationship: [{ name: "SP" }, { name: "C" }],
        gender: [
            { id: "M", name: "M" },
            { id: "F", name: "F" },
        ],
        coverage: [
            { id: "1", name: "EE" },
            { id: "2", name: "ES" },
            { id: "3", name: "EC" },
            { id: "4", name: "EF" },
            { id: "5", name: "W" },
        ],
        coverage2: [
            { id: "1", name: "EE" },
            { id: "5", name: "W" },
        ],
        yesNo: [
            { id: "1", name: "Yes" },
            { id: "0", name: "No" },
        ],
        currentTab: "",
        employer: {},
        census: {},
        states: [],
        counties: [],
        selectedCounty: "",
        newHireUsers: [],
        carriers: [],
        payrollCycles: [],
        brokers: [],
        employerLoaded: false,
        stateText: "",
        broker: "",
        salesRepresentative: "",
        specialSalesRepresentative: "",
        renewalRepresentative: "",
        errors: [],
        years: [],
        selectedYear: "",
        columnLabels: [
            "Quote",
            "Eff. Date",
            "Status",
            "Quoted on",
            "Quoted By",
            "Sales Rep",
            "Broker",
            "Latest Proposal",
            "# of Props",
        ],
        columnValues: [
            "quoteNumber",
            "effectiveDateString",
            "quoteStatus",
            "createDateString",
            "createdBy",
            "salesRepName",
            "brokerName",
            "latestProposal",
            "proposalCount",
        ],
        quotes: [],
        selectedQuote: "",
        notes: [],
        uniqueIds: [],
        selectedUniqueId: "",
        showUploadCensusModal: false,
        censusUpload: null,
        isSubmittingCensus: false,
        currentCensus: 1,
        censusEditMode: false,
        showModalAge: false,
        worksheetRenewalDate: null,
        worksheetEmployeeEnrollmentDate: null,
        worksheetRatingArea: "",
        worksheetCarrier: "",
        worksheetFrequency: "",
        worksheetApplyRolloverBalanceToDependents: true,
        worksheetBaseCarrier: "",
        worksheetBasePlan: "",
        worksheetBasePlanName: "",
        worksheetHasBasePlan: false,
        worksheetRenewalCarriers: [],
        worksheetRenewalPlans: [],
        worksheetContributionIsPercent: true,
        worksheetEeContribution: "",
        worksheetDepContribution: "",
        worksheetSelectedRows: {},
        worksheetPossiblePlans: [],
        worksheetPossiblePlansFilter: "",
        showWorksheetPossiblePlansFilter: false,
        worksheetSelectedPlans: [],
        worksheetPossiblePlansLoading: false,
        isSubmittingWorksheet: false,
    };

    componentDidMount() {
        this._mounted = true;

        const employerId = this.props.match.params.id;

        employerApi.getById(employerId).then(response => {
            this._employerLoaded(response);
            Promise.all([
                dataApi.getStates(),
                dataApi.getPayrollCycles(),
                dataApi.getUsers(),
                employerApi.getNotes(employerId),
                dataApi.getCarriers(),
                censusApi.getCensusUniqueIdsByEmployerId(employerId),
            ])
                .then(responses => {
                    if (
                        responses &&
                        responses[0] &&
                        responses[1] &&
                        responses[2] &&
                        responses[3] &&
                        responses[4] &&
                        responses[5] &&
                        this._mounted
                    ) {
                        this.setState({
                            states: responses[0],
                            payrollCycles: responses[1],
                            newHireUsers: responses[2],
                            notes: responses[3],
                            carriers: responses[4],
                            uniqueIds: responses[5],
                        });
                    }
                })
                .catch(err => logger.log(err));
        });

        //years...
        const years = [];
        const dt = new Date();
        years.push((dt.getFullYear() + 1).toString());
        years.push(dt.getFullYear().toString());
        years.push((dt.getFullYear() - 1).toString());
        this.setState({
            years: years,
            selectedYear: dt.getFullYear().toString(),
        });
    }

    _normalizeCensusRows = censusRows =>
        (censusRows || []).map(row => ({
            ...row,
            isPPO: row.isPPO !== null && row.isPPO !== undefined ? row.isPPO : true,
            isHMO: row.isHMO !== null && row.isHMO !== undefined ? row.isHMO : true,
            dependents: (row.dependents || []).map(dep => ({
                ...dep,
                childDependentStatus:
                    dep.dependentType !== "Spouse"
                        ? dep.childDependentStatus || "Child"
                        : dep.childDependentStatus || null,
                homePostalCode: !ENABLE_DEPENDENT_ZIP_EDIT
                    ? row.homePostalCode || dep.homePostalCode || ""
                    : dep.homePostalCode,
            })),
        }));

    _getEmployeeHomeZipForRow = (censusRows, row) => {
        if (!row || row.relationship === "EE") {
            return (row && row.homePostalCode) || "";
        }

        const sequencePrefix = row.sequenceNumber
            ? row.sequenceNumber.toString().split(".")[0]
            : null;

        if (!sequencePrefix) {
            return row.homePostalCode || "";
        }

        const employeeRow = (censusRows || []).find(
            cen =>
                cen.relationship === "EE" &&
                cen.sequenceNumber &&
                cen.sequenceNumber.toString() === sequencePrefix,
        );

        return (employeeRow && employeeRow.homePostalCode) || row.homePostalCode || "";
    };

    _getEmployer = id => {
        this.setState({ loading: true });

        employerApi.getById(id).then(response => {
            this._employerLoaded(response);
        });
    };

    _employerLoaded = employer => {
        let { employerAddress } = employer;

        if (!employerAddress) {
            employerAddress = {};
            employerAddress.street1 = "";
            employerAddress.street2 = "";
            employerAddress.city = "";
            employerAddress.stateId = null;
            employerAddress.postalCode = "";
            employerAddress.countyId = null;
            employerAddress.vericredFipsCode = "";
        }

        if (employer.salesRepresentativeId) {
            const user = this.state.newHireUsers.find(
                p => p.id === parseInt(employer.salesRepresentativeId),
            );
            if (user) {
                this.setState({ salesRepresentative: user.fullName });
            }
        }

        if (employer.specialSalesRepresentativeId) {
            const user = this.state.newHireUsers.find(
                p => p.id === parseInt(employer.specialSalesRepresentativeId),
            );
            if (user) {
                this.setState({ specialSalesRepresentative: user.fullName });
            }
        }

        if (employer.renewalRepresentativeId) {
            const user = this.state.newHireUsers.find(
                p => p.id === parseInt(employer.renewalRepresentativeId),
            );
            if (user) {
                this.setState({ renewalRepresentative: user.fullName });
            }
        }

        employer.employerAddress = employerAddress;

        this.setState(prevState => {
            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.name]: employer.name,
                    [inputNames.isVirgin]: employer.isVirgin,
                    [inputNames.isTest]: employer.isTest,
                    [inputNames.contactName]: employer.contactName ? employer.contactName : "",
                    [inputNames.phone]: employer.phone ? employer.phone : "",
                    [inputNames.street1]: employerAddress.street1 ? employerAddress.street1 : "",
                    [inputNames.street2]: employerAddress.street2 ? employerAddress.street2 : "",
                    [inputNames.city]: employerAddress.city ? employerAddress.city : "",
                    [inputNames.stateId]: employerAddress.stateId ? employerAddress.stateId : null,
                    [inputNames.postalCode]: employerAddress.postalCode
                        ? employerAddress.postalCode
                        : "",
                    [inputNames.vericredFipsCode]: employerAddress.vericredFipsCode
                        ? employerAddress.vericredFipsCode
                        : "",
                    [inputNames.countyId]:
                        employerAddress.countyId || employer.countyId
                            ? (employerAddress.countyId || employer.countyId).toString()
                            : null,
                    [inputNames.sicCodeId]: employer.sicCodeId ? employer.sicCodeId : null,
                    [inputNames.segmentSize]: employer.segmentSize ? employer.segmentSize : "",
                    [inputNames.salesRepresentativeId]: employer.salesRepresentativeId
                        ? employer.salesRepresentativeId
                        : null,
                    [inputNames.specialSalesRepresentativeId]: employer.specialSalesRepresentativeId
                        ? employer.specialSalesRepresentativeId
                        : null,
                    [inputNames.renewalRepresentativeId]: employer.renewalRepresentativeId
                        ? employer.renewalRepresentativeId
                        : null,
                    [inputNames.payrollCycleId]: employer.payrollCycleId
                        ? employer.payrollCycleId
                        : null,
                    [inputNames.brokerId]: employer.brokerId ? employer.brokerId : null,
                    [inputNames.medicalRenewalDate]: employer.medicalRenewalDate
                        ? new Date(employer.medicalRenewalDate)
                        : null,
                    [inputNames.medicalEffectiveDate]: employer.medicalEffectiveDate
                        ? new Date(employer.medicalEffectiveDate)
                        : null,
                    [inputNames.medicalPriorCarrier]: employer.medicalPriorCarrier
                        ? employer.medicalPriorCarrier
                        : "",
                    [inputNames.dentalPriorCarrier]: employer.dentalPriorCarrier
                        ? employer.dentalPriorCarrier
                        : "",
                    [inputNames.visionPriorCarrier]: employer.visionPriorCarrier
                        ? employer.visionPriorCarrier
                        : "",
                    [inputNames.lifePriorCarrier]: employer.lifePriorCarrier
                        ? employer.lifePriorCarrier
                        : "",
                    [inputNames.isExistingClient]: employer.isExistingClient,
                    [inputNames.isCobra]: employer.isCobra,
                    [inputNames.alias]: employer.alias,
                },
                stateText: employerAddress.state,
                counties:
                    employerAddress.countyId || employer.countyId
                        ? [
                              {
                                  id: employerAddress.countyId || employer.countyId,
                                  name:
                                      employerAddress.countyName ||
                                      employerAddress.county ||
                                      employer.countyName ||
                                      employer.county ||
                                      "",
                                  ratingArea: null,
                              },
                          ]
                        : [],
                selectedCounty:
                    employerAddress.countyName ||
                    employerAddress.county ||
                    employer.countyName ||
                    employer.county ||
                    "",
                employer,
                quotes: employer.quotes,
                selectedQuote:
                    employer.census && employer.census.length > 0 && employer.census[0].quoteId
                        ? employer.census[0].quoteId.toString()
                        : "",
                census: this._normalizeCensusRows(employer.census),
                employerLoaded: true,
            };
        });
    };

    _handleTextChange = e => {
        const { name } = e.target;
        let { value } = e.target;
        const { employer, selectedCounty } = this.state;

        if (name === inputNames.phone) {
            value = util.maskPhoneNumber(value);
        } else if (name === inputNames.postalCode) {
            value = value.replace(/[^0-9]+/g, "");
            //maxlength of 5
            if (value && value.length === 6) {
                return;
            } else if (value && value.length === 5) {
                employerApi.checkZip(value, "-1").then(response => {
                    if (
                        response &&
                        response.success &&
                        response.message &&
                        response.message.startsWith("single")
                    ) {
                        const countyJSON = JSON.parse(response.message.split("|")[1]);
                        if (countyJSON && countyJSON[0]) {
                            this.setState(prevState => {
                                const errors = { ...prevState.errors };
                                delete errors[inputNames.countyId];

                                return {
                                    inputs: {
                                        ...prevState.inputs,
                                        [inputNames.countyId]: countyJSON[0].id.toString(),
                                    },
                                    counties: countyJSON,
                                    selectedCounty: countyJSON[0].name,
                                    errors,
                                };
                            });
                        }
                    } else if (
                        response &&
                        !response.success &&
                        response.message &&
                        response.message.startsWith("multiple")
                    ) {
                        const countiesJSON = JSON.parse(response.message.split("|")[1]);
                        let selectedCountyId = null;
                        const preferredCountyName =
                            selectedCounty ||
                            (employer && employer.county) ||
                            (employer && employer.countyName) ||
                            (employer &&
                                employer.employerAddress &&
                                employer.employerAddress.countyName) ||
                            (employer &&
                                employer.employerAddress &&
                                employer.employerAddress.county) ||
                            "";

                        if (preferredCountyName) {
                            countiesJSON.forEach(c => {
                                if (
                                    !selectedCountyId &&
                                    c &&
                                    c.name &&
                                    c.name.startsWith(preferredCountyName)
                                ) {
                                    selectedCountyId = c.id.toString();
                                }
                            });
                        }

                        if (selectedCountyId) {
                            toast.info(
                                "We auto-selected the same county on this multi-county zip. You can adjust the selected county (if needed) before proceeding.",
                                { toastId: 1 },
                            );
                        } else {
                            toast.warning(
                                "The multi-county zip code that you entered requires you to choose a county before proceeding.",
                                { toastId: 1 },
                            );
                        }

                        this.setState(prevState => {
                            const errors = { ...prevState.errors };
                            if (selectedCountyId) {
                                delete errors[inputNames.countyId];
                            } else {
                                errors[inputNames.countyId] = "required";
                            }

                            return {
                                inputs: {
                                    ...prevState.inputs,
                                    [inputNames.countyId]: selectedCountyId,
                                },
                                counties: countiesJSON,
                                selectedCounty: selectedCountyId
                                    ? countiesJSON.find(c => c.id.toString() === selectedCountyId)
                                          .name
                                    : "",
                                errors,
                            };
                        });
                    } else if (response && !response.success && response.message) {
                        this.setState(prevState => {
                            const errors = { ...prevState.errors };
                            delete errors[inputNames.countyId];

                            return {
                                inputs: {
                                    ...prevState.inputs,
                                    [inputNames.countyId]: null,
                                },
                                counties: [],
                                selectedCounty: "",
                                errors,
                            };
                        });
                    }
                });
            } else {
                this.setState(prevState => {
                    const errors = { ...prevState.errors };
                    delete errors[inputNames.countyId];

                    return {
                        inputs: {
                            ...prevState.inputs,
                            [inputNames.countyId]: null,
                        },
                        counties: [],
                        selectedCounty: "",
                        errors,
                    };
                });
            }
        }
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[name];
            return {
                inputs: {
                    ...prevState.inputs,
                    [name]: value,
                },
                errors,
            };
        });
    };

    _handleCountyIdChanged = item => {
        const { counties } = this.state;
        const county = counties.find(c => c.id.toString() === item.value);

        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.countyId];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.countyId]: item.value,
                },
                selectedCounty: county && county.name ? county.name : "",
                errors,
            };
        });
    };

    _handleSegmentSizeChange = value => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.segmentSize];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.segmentSize]: value,
                },
                errors,
            };
        });
    };

    _handlePayrollCycleChange = (value, index) => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.payrollCycleId];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.payrollCycleId]: value,
                },
                payrollCycle: this.state.payrollCycles[index].name,
                errors,
            };
        });
    };

    _handleStateChange = (value, index) => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.stateId];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.stateId]: value,
                },
                stateText: this.state.states[index].name,
                errors,
            };
        });
    };

    _handleSalesRepresentativeChange = value => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.salesRepresentativeId];
            const user = this.state.newHireUsers.find(p => p.id === parseInt(value));

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.salesRepresentativeId]: value,
                },
                salesRepresentative: user.fullName,
                errors,
            };
        });
    };

    _handleSpecialSalesRepresentativeChange = value => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.specialSalesRepresentativeId];
            const user = this.state.newHireUsers.find(p => p.id === parseInt(value));

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.specialSalesRepresentativeId]: value,
                },
                specialSalesRepresentative: user.fullName,
                errors,
            };
        });
    };

    _handleRenewalRepresentativeChange = value => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.renewalRepresentativeId];

            const user = this.state.newHireUsers.find(p => p.id === parseInt(value));

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.renewalRepresentativeId]: value,
                },
                renewalRepresentative: user.fullName,
                errors,
            };
        });
    };

    _brokerSelected = item => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.brokerId];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.brokerId]: item.value,
                },
                broker: item.label,
                errors,
            };
        });
    };

    _goToBroker = id => {
        if (id > 0) {
            window.location.href = "/brokers/detail/" + id;
        }
    };

    _handleDateChange = (value, name) => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[name];

            return {
                inputs: {
                    ...prevState.inputs,
                    [name]: value,
                },
                errors,
            };
        });
    };

    _sicCodeSelected = item => {
        this.setState(prevState => {
            const errors = { ...prevState.errors };
            delete errors[inputNames.sicCodeId];

            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.sicCodeId]: item.value,
                },
                sicCode: item.label,
                errors,
            };
        });
    };

    _handleInputChange = e => {
        const { checked, name, type, value } = e.target;
        const val = type === "checkbox" ? checked : value;

        this.setState(
            prevState => {
                const errors = { ...prevState.errors };
                delete errors[name];

                return {
                    inputs: {
                        ...prevState.inputs,
                        [name]: val,
                    },
                    errors,
                };
            },
            () => {
                if (type === "checkbox") {
                    this._handleOnSave();
                }
            },
        );
    };

    _handleYesNoChanged = selectedItem => {
        const { name, value } = selectedItem;

        this.setState(prevState => {
            return {
                inputs: {
                    ...prevState.inputs,
                    [name]: value,
                },
            };
        });
    };

    _toggleWorksheetRowSelection = (sequenceNumber, isChecked) => {
        this.setState(prevState => ({
            worksheetSelectedRows: {
                ...prevState.worksheetSelectedRows,
                [sequenceNumber]: isChecked,
            },
        }));
    };

    //_changeYear = item => {
    _changeYearQuotes = item => {
        const { employer } = this.state;
        const quotes =
            employer.quotes &&
            employer.quotes.filter(x => x.effectiveDateString.indexOf(item.value.substr(-2)) > -1);

        this.setState({
            selectedYear: item.value,
            quotes: quotes,
        });
    };

    _changeCensus = item => {
        const employerId = this.props.match.params.id;
        const { selectedQuote } = this.state;
        if (item.value === selectedQuote) {
            return;
        }
        //continue the load
        this.setState({ isSubmittingCensus: true });
        if (item.value.length === 36) {
            censusApi
                .getCensusByUniqueId(employerId, item.value)
                .then(response => {
                    this.setState({
                        selectedQuote: item.value.toLowerCase(),
                        census: this._normalizeCensusRows(response),
                        currentCensus: response.length + 1,
                        isSubmittingCensus: false,
                        censusEditMode: false,
                    });
                })
                .catch(err => logger.log(err));
        } else {
            censusApi
                .getCensusByQuoteId(item.value)
                .then(response => {
                    this.setState({
                        selectedQuote: item.value.toLowerCase(),
                        census: this._normalizeCensusRows(response),
                        isSubmittingCensus: false,
                        censusEditMode: false,
                    });
                })
                .catch(err => logger.log(err));
        }
    };

    _setFirstName = (e, c, d) => {
        const val = e.target.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.firstName = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, firstName: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.firstName = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, firstName: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setLastName = (e, c, d) => {
        const val = e.target.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.lastName = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, lastName: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.lastName = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, lastName: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setDOB = (e, c, d) => {
        //valid date
        const val = util.maskDate(e.target.value);
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.birthDate = val;
                matchC.birthDateString = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, birthDate: val, birthDateString: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.birthDate = val;
                    matchD.birthDateString = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, birthDate: val, birthDateString: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setGender = (e, c, d) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.gender = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, gender: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.gender = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, gender: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setMedicalCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        const cvg =
            val === "1" ? "EE" : val === "2" ? "ES" : val === "3" ? "EC" : val === "4" ? "EF" : "W";
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.medicalCoverageId = val;
                matchC.medicalCoverage = cvg;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, medicalCoverageId: val, medicalCoverage: cvg }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.medicalCoverageId = val;
                    matchD.medicalCoverage = cvg;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, medicalCoverageId: val, medicalCoverage: cvg }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setDentalCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        const cvg =
            val === "1" ? "EE" : val === "2" ? "ES" : val === "3" ? "EC" : val === "4" ? "EF" : "W";
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.dentalCoverageId = val;
                matchC.dentalCoverage = cvg;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, dentalCoverageId: val, dentalCoverage: cvg }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.dentalCoverageId = val;
                    matchD.dentalCoverage = cvg;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, dentalCoverageId: val, dentalCoverage: cvg }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setVisionCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        const cvg =
            val === "1" ? "EE" : val === "2" ? "ES" : val === "3" ? "EC" : val === "4" ? "EF" : "W";
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.visionCoverageId = val;
                matchC.visionCoverage = cvg;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, visionCoverageId: val, visionCoverage: cvg }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.visionCoverageId = val;
                    matchD.visionCoverage = cvg;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, visionCoverageId: val, visionCoverage: cvg }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setLifeCoverage = (e, c, d) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        const cvg = val === "1" ? "EE" : "W";
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.lifeCoverageId = val;
                matchC.lifeCoverage = cvg;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, lifeCoverageId: val, lifeCoverage: cvg }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.lifeCoverageId = val;
                    matchD.lifeCoverage = cvg;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, lifeCoverageId: val, lifeCoverage: cvg }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setHZip = (e, c, d) => {
        //valid postal code
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 6) {
            return;
        }

        if (d !== null && !ENABLE_DEPENDENT_ZIP_EDIT) {
            return;
        }

        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.homePostalCode = val;
                if (!ENABLE_DEPENDENT_ZIP_EDIT && matchC.dependents) {
                    matchC.dependents = matchC.dependents.map(dep => ({
                        ...dep,
                        homePostalCode: val,
                    }));
                }
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? {
                              ...person,
                              homePostalCode: val,
                              dependents: !ENABLE_DEPENDENT_ZIP_EDIT
                                  ? (person.dependents || []).map(dep => ({
                                        ...dep,
                                        homePostalCode: val,
                                    }))
                                  : person.dependents,
                          }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.homePostalCode = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, homePostalCode: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setWZip = (e, c) => {
        //valid postal code
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 6) {
            return;
        }
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.workPostalCode = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, workPostalCode: val }
                    : person,
            ),
        });
    };

    _setOccupation = (e, c) => {
        const val = e.target.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.occupation = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, occupation: val }
                    : person,
            ),
        });
    };

    _setSalary = (e, c) => {
        //valid number
        let val = e.target.value;
        val = val.replace(/[^0-9]+/g, "");
        if (val && val.length === 7) {
            return;
        }
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.salary = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, salary: val } : person,
            ),
        });
    };

    _setDOH = (e, c) => {
        //valid date
        const val = util.maskDate(e.target.value);
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census
        if (matchC) {
            matchC.hireDate = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, hireDate: val, hireDateString: val }
                    : person,
            ),
        });
    };

    _setEnrollmentDate = (e, c) => {
        const val = util.maskDate(e.target.value);
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.enrollmentDate = val;
            matchC.enrollmentDateString = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, enrollmentDate: val, enrollmentDateString: val }
                    : person,
            ),
        });
    };

    _setEmail = (e, c) => {
        const val = e.target.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.email = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, email: val } : person,
            ),
        });
    };

    _setTobacco = (e, c, d) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        //census or dependent?
        if (d === null) {
            if (matchC) {
                matchC.isTobacco = val;
            }

            this.setState({
                census: this.state.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, isTobacco: val }
                        : person,
                ),
            });
        } else {
            if (matchC) {
                const matchD = matchC.dependents.find(
                    dep => dep.sequenceNumber === d.sequenceNumber,
                );
                if (matchD) {
                    matchD.isTobacco = val;
                }
            }

            this.setState(prevState => ({
                census: prevState.census.map(cen => {
                    if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                        return {
                            ...cen,
                            dependents: cen.dependents.map(person =>
                                person.sequenceNumber === d.sequenceNumber
                                    ? { ...person, isTobacco: val }
                                    : person,
                            ),
                        };
                    }
                    return cen;
                }),
            }));
        }
    };

    _setCOB = (e, c) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.onCobra = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, onCobra: val } : person,
            ),
        });
    };

    _setCurrentPlan = (e, c) => {
        const val = e.value;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.currentMedicalPlanId = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, currentMedicalPlanId: val }
                    : person,
            ),
        });
    };

    _setPPO = (e, c) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.isPPO = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, isPPO: val } : person,
            ),
        });
    };

    _setHMO = (e, c) => {
        const val = e.value === "1" ? true : false;
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC) {
            matchC.isHMO = val;
        }

        this.setState({
            census: this.state.census.map(person =>
                person.sequenceNumber === c.sequenceNumber ? { ...person, isHMO: val } : person,
            ),
        });
    };

    _toggleAllCensusCheckboxes = (field, value) => e => {
        e.preventDefault();
        this.setState(prevState => ({
            census: prevState.census.map(person => {
                const updated = { ...person, [field]: value };

                if (field === "isTobacco" && person.dependents && person.dependents.length > 0) {
                    updated.dependents = person.dependents.map(dep => ({
                        ...dep,
                        isTobacco: value,
                    }));
                }

                return updated;
            }),
        }));
    };

    _handleCensusCheckboxChange = (e, c, d = null) => {
        const { checked, name } = e.target;
        const fieldMap = {
            [inputNames.isPPO]: "isPPO",
            [inputNames.isHMO]: "isHMO",
            [inputNames.onCobra]: "onCobra",
            [inputNames.isTobacco]: "isTobacco",
        };

        const field = fieldMap[name];
        if (!field) {
            return;
        }

        this.setState(prevState => ({
            census: prevState.census.map(person => {
                if (person.sequenceNumber !== c.sequenceNumber) {
                    return person;
                }

                if (d === null) {
                    return { ...person, [field]: checked };
                }

                if (field !== "isTobacco") {
                    return person;
                }

                return {
                    ...person,
                    dependents: (person.dependents || []).map(dep =>
                        dep.sequenceNumber === d.sequenceNumber
                            ? { ...dep, [field]: checked }
                            : dep,
                    ),
                };
            }),
        }));
    };

    _setRelationship = (e, c, d) => {
        const val = e.value;
        const dependentType = val === "SP" ? "Spouse" : "Child";
        const childDependentStatus =
            val === "SP" ? null : d && d.childDependentStatus ? d.childDependentStatus : "Child";

        // Flat census rows store dependents as regular census records (no nested dependent object).
        if (d === null) {
            this.setState(prevState => ({
                census: prevState.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? {
                              ...person,
                              relationship: val,
                              dependentType,
                              childDependentStatus,
                          }
                        : person,
                ),
            }));

            return;
        }

        this.setState(prevState => ({
            census: prevState.census.map(cen => {
                if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                    return {
                        ...cen,
                        dependents: cen.dependents.map(person =>
                            person.sequenceNumber === d.sequenceNumber
                                ? {
                                      ...person,
                                      relationship: val,
                                      dependentType,
                                      childDependentStatus,
                                  }
                                : person,
                        ),
                    };
                }
                return cen;
            }),
        }));
    };

    _setChildDependentStatus = (e, c, d) => {
        const val = e.value;
        // Flat census rows store dependents as regular census records (no nested dependent object).
        if (d === null) {
            this.setState(prevState => ({
                census: prevState.census.map(person =>
                    person.sequenceNumber === c.sequenceNumber
                        ? { ...person, childDependentStatus: val }
                        : person,
                ),
            }));

            return;
        }

        this.setState(prevState => ({
            census: prevState.census.map(cen => {
                if (cen.dependents.some(dep => dep.sequenceNumber === d.sequenceNumber)) {
                    return {
                        ...cen,
                        dependents: cen.dependents.map(person =>
                            person.sequenceNumber === d.sequenceNumber
                                ? { ...person, childDependentStatus: val }
                                : person,
                        ),
                    };
                }
                return cen;
            }),
        }));
    };

    _addCensusMember = () => {
        const { employer, census, currentCensus, selectedQuote } = this.state;
        const newCensus = {
            uniqueId: selectedQuote,
            employerId: employer.id,
            sequenceNumber: currentCensus.toString(),
            relationship: "EE",
            firstName: "",
            lastName: "",
            birthDate: "",
            gender: "M",
            medicalCoverageId: 1,
            medicalCoverage: "EE",
            dentalCoverageId: 1,
            dentalCoverage: "EE",
            visionCoverageId: 1,
            visionCoverage: "EE",
            lifeCoverageId: 1,
            lifeCoverage: "EE",
            homePostalCode: "",
            workPostalCode: "",
            occupation: "",
            salary: "",
            enrollmentDate: "",
            isTobacco: false,
            isPPO: true,
            isHMO: true,
            onCobra: false,
            dependents: [],
        };
        const joined = census.concat(newCensus);
        this.setState(
            {
                census: joined,
                currentCensus: currentCensus + 1,
            },
            () => {
                if (this.censusBottomRef.current) {
                    this.censusBottomRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                    });
                }
            },
        );
        //scroll to top of page
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
        });
    };

    _removeCensusMember = c => {
        const { census } = this.state;
        if (!census) {
            this.setState({ census: [], currentCensus: 1 });
        } else {
            const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
            if (matchC) {
                const spliced = [...census];
                const index = spliced.indexOf(matchC);
                if (index > -1) {
                    spliced.splice(index, 1);
                    this.setState(
                        {
                            census: spliced,
                        },
                        () => {
                            this._reNumberCensus();
                        },
                    );
                }
            }
        }
    };

    _addDependent = c => {
        const { census } = this.state;
        const lngth = (c.dependents.length + 1).toString();
        const newDep = {
            sequenceNumber: c.sequenceNumber + "." + lngth,
            relationship: c.medicalCoverageId === "3" ? "C" : lngth === "1" ? "SP" : "C",
            dependentType:
                c.medicalCoverageId === "3" ? "Child" : lngth === "1" ? "Spouse" : "Child",
            firstName: "",
            lastName: "",
            birthDate: "",
            gender: "M",
            homePostalCode: !ENABLE_DEPENDENT_ZIP_EDIT ? c.homePostalCode || "" : "",
            isTobacco: false,
            childDependentStatus:
                c.medicalCoverageId === "3" ? "Child" : lngth === "1" ? null : "Child",
        };
        const joined = c.dependents.concat(newDep);

        this.setState({
            census: census.map(person =>
                person.sequenceNumber === c.sequenceNumber
                    ? { ...person, dependents: joined }
                    : person,
            ),
        });
    };

    _removeDependent = (c, d) => {
        const { census } = this.state;
        const matchC = census.find(cen => cen.sequenceNumber === c.sequenceNumber);
        if (matchC && matchC.dependents.length > 0) {
            const matchD = matchC.dependents.find(dep => dep.sequenceNumber === d.sequenceNumber);
            if (matchD) {
                const spliced = [...matchC.dependents];
                const index = matchC.dependents.indexOf(matchD);
                if (index > -1) {
                    spliced.splice(index, 1);
                    this.setState(
                        {
                            census: census.map(person =>
                                person.sequenceNumber === c.sequenceNumber
                                    ? { ...person, dependents: spliced }
                                    : person,
                            ),
                        },
                        () => {
                            this._reNumberCensus();
                        },
                    );
                }
            }
        }
    };

    _reNumberCensus = () => {
        const { census } = this.state;
        if (census && census.length > 1) {
            //make a copy
            const updated = [...census];
            for (let i = 0; i < updated.length; i++) {
                updated[i].sequenceNumber = (i + 1).toString();
                if (updated[i].dependents && updated[i].dependents.length > 0) {
                    for (let j = 0; j < updated[i].dependents.length; j++) {
                        updated[i].dependents[j].sequenceNumber =
                            (i + 1).toString() + "." + (j + 1).toString();
                    }
                }
            }
            this.setState({
                census: updated,
                currentCensus: updated.length + 1,
            });
        }
    };

    _handleRowClick = id => {
        this.props.history.push(routeHelpers.quoteDetail(id));
    };

    _sortQuotes = (page, col, dir) => {
        const { quotes } = this.state;
        if (dir === "asc") {
            this.setState({
                quotes: sortBy(quotes, col),
            });
        } else {
            this.setState({
                quotes: sortBy(quotes, col).reverse(),
            });
        }
    };

    _renderQuotes = () => {
        const { quotes } = this.state;

        return (
            <div className={css(styles.tabContent)}>
                <div className={css(styles.row)}>
                    <div className={css(styles.right)}>
                        {quotes ? parseInt(quotes.length).toLocaleString() : "0"} quotes
                    </div>
                    {quotes && quotes.length > 0 ? (
                        <Infinite
                            results={quotes}
                            length={quotes.length}
                            columnLabels={this.state.columnLabels}
                            columnValues={this.state.columnValues}
                            showChevron={true}
                            showMore={false}
                            onClick={this._handleRowClick}
                            onScroll={this._sortQuotes}
                        />
                    ) : (
                        <div className={css(styles.noResults)}>
                            {this.state.loading ? "Loading " : "No Matching "} quotes
                        </div>
                    )}
                </div>
            </div>
        );
    };

    _renderCensus = () => {
        const {
            employer,
            census,
            selectedQuote,
            censusEditMode,
            worksheetSelectedRows,
        } = this.state;
            const employerAddress = employer && employer.employerAddress ? employer.employerAddress : {};
            const employerAreaId = employer.areaId || employerAddress.areaId;
            const employerState = employer.state || employerAddress.state;
        const hasGeneralInfoCounty = this._hasGeneralInfoCounty();
        const showPlanTypeColumns =
            !!employer &&
                (employerAreaId === 32 ||
                    (employerState && employerState.toString().toUpperCase() === "CA"));
        const editableColSpan = showPlanTypeColumns ? 22 : 20;
        return (
            <div className={css(styles.tabContent)}>
                <div className={css(styles.row)}>
                    <table className={css(styles.table)}>
                        <thead>
                            <tr>
                                <td className={css(styles.tableHeader)}>No.</td>
                                {!censusEditMode && hasGeneralInfoCounty ? (
                                    <td
                                        className={css(
                                            styles.tableHeader,
                                            styles.tableCheckboxCell,
                                        )}
                                    >
                                        Sel
                                    </td>
                                ) : null}
                                <td className={css(styles.tableHeader)}>Rel</td>
                                {census &&
                                selectedQuote &&
                                selectedQuote.length === 36 &&
                                censusEditMode ? (
                                    <td className={css(styles.tableHeader)}>First Name</td>
                                ) : (
                                    <td className={css(styles.tableHeader)}>Name</td>
                                )}
                                {census &&
                                selectedQuote &&
                                selectedQuote.length === 36 &&
                                censusEditMode ? (
                                    <td className={css(styles.tableHeader)}>Last Name</td>
                                ) : null}
                                <td className={css(styles.tableHeader)}>DOB</td>
                                {census &&
                                selectedQuote &&
                                selectedQuote.length === 36 &&
                                censusEditMode ? null : (
                                    <td className={css(styles.tableHeader)}>Age</td>
                                )}
                                <td className={css(styles.tableHeader)}>Gen</td>
                                <td className={css(styles.tableHeader)}>Med</td>
                                <td className={css(styles.tableHeader)}>Den</td>
                                <td className={css(styles.tableHeader)}>Vis</td>
                                <td className={css(styles.tableHeader)}>Lif</td>
                                <td className={css(styles.tableHeader)}>H Zip</td>
                                <td className={css(styles.tableHeader)}>W Zip</td>
                                <td className={css(styles.tableHeader)}>Title</td>
                                <td className={css(styles.tableHeader)}>Salary</td>
                                <td className={css(styles.tableHeader)}>Email</td>
                                <td className={css(styles.tableHeader)}>Current Plan</td>
                                <td className={css(styles.tableHeader)}>EE Eff Date</td>
                                {showPlanTypeColumns ? (
                                    censusEditMode ? (
                                        <td
                                            className={css(
                                                styles.tableHeader,
                                                styles.planFlagHeader,
                                                styles.tablePlanFlagCell,
                                            )}
                                        >
                                            <div className={css(styles.planHeaderLabel)}>PPO</div>
                                            <div className={css(styles.planHeaderLinks)}>
                                                <a
                                                    href="#"
                                                    className={css(styles.planHeaderLink)}
                                                    onClick={this._toggleAllCensusCheckboxes(
                                                        "isPPO",
                                                        true,
                                                    )}
                                                >
                                                    All
                                                </a>
                                                {" | "}
                                                <a
                                                    href="#"
                                                    className={css(styles.planHeaderLink)}
                                                    onClick={this._toggleAllCensusCheckboxes(
                                                        "isPPO",
                                                        false,
                                                    )}
                                                >
                                                    None
                                                </a>
                                            </div>
                                        </td>
                                    ) : (
                                        <td
                                            className={css(
                                                styles.tableHeader,
                                                styles.tablePlanFlagHeaderCell,
                                            )}
                                        >
                                            PPO
                                        </td>
                                    )
                                ) : null}
                                {showPlanTypeColumns ? (
                                    censusEditMode ? (
                                        <td
                                            className={css(
                                                styles.tableHeader,
                                                styles.planFlagHeader,
                                                styles.tablePlanFlagCell,
                                            )}
                                        >
                                            <div className={css(styles.planHeaderLabel)}>HMO</div>
                                            <div className={css(styles.planHeaderLinks)}>
                                                <a
                                                    href="#"
                                                    className={css(styles.planHeaderLink)}
                                                    onClick={this._toggleAllCensusCheckboxes(
                                                        "isHMO",
                                                        true,
                                                    )}
                                                >
                                                    All
                                                </a>
                                                {" | "}
                                                <a
                                                    href="#"
                                                    className={css(styles.planHeaderLink)}
                                                    onClick={this._toggleAllCensusCheckboxes(
                                                        "isHMO",
                                                        false,
                                                    )}
                                                >
                                                    None
                                                </a>
                                            </div>
                                        </td>
                                    ) : (
                                        <td
                                            className={css(
                                                styles.tableHeader,
                                                styles.tablePlanFlagHeaderCell,
                                            )}
                                        >
                                            HMO
                                        </td>
                                    )
                                ) : null}
                                {censusEditMode ? (
                                    <td
                                        className={css(
                                            styles.tableHeader,
                                            styles.planFlagHeader,
                                            styles.tablePlanFlagCell,
                                        )}
                                    >
                                        <div className={css(styles.planHeaderLabel)}>COB</div>
                                        <div className={css(styles.planHeaderLinks)}>
                                            <a
                                                href="#"
                                                className={css(styles.planHeaderLink)}
                                                onClick={this._toggleAllCensusCheckboxes(
                                                    "onCobra",
                                                    true,
                                                )}
                                            >
                                                All
                                            </a>
                                            {" | "}
                                            <a
                                                href="#"
                                                className={css(styles.planHeaderLink)}
                                                onClick={this._toggleAllCensusCheckboxes(
                                                    "onCobra",
                                                    false,
                                                )}
                                            >
                                                None
                                            </a>
                                        </div>
                                    </td>
                                ) : (
                                    <td
                                        className={css(
                                            styles.tableHeader,
                                            styles.tablePlanFlagHeaderCell,
                                        )}
                                    >
                                        COB
                                    </td>
                                )}
                                {censusEditMode ? (
                                    <td
                                        className={css(
                                            styles.tableHeader,
                                            styles.planFlagHeader,
                                            styles.tablePlanFlagCell,
                                        )}
                                    >
                                        <div className={css(styles.planHeaderLabel)}>Tob</div>
                                        <div className={css(styles.planHeaderLinks)}>
                                            <a
                                                href="#"
                                                className={css(styles.planHeaderLink)}
                                                onClick={this._toggleAllCensusCheckboxes(
                                                    "isTobacco",
                                                    true,
                                                )}
                                            >
                                                All
                                            </a>
                                            {" | "}
                                            <a
                                                href="#"
                                                className={css(styles.planHeaderLink)}
                                                onClick={this._toggleAllCensusCheckboxes(
                                                    "isTobacco",
                                                    false,
                                                )}
                                            >
                                                None
                                            </a>
                                        </div>
                                    </td>
                                ) : (
                                    <td
                                        className={css(
                                            styles.tableHeader,
                                            styles.tablePlanFlagHeaderCell,
                                        )}
                                    >
                                        Tob
                                    </td>
                                )}
                                {census &&
                                selectedQuote &&
                                selectedQuote.length === 36 &&
                                censusEditMode ? (
                                    <td className={css(styles.tableHeader)}> </td>
                                ) : null}
                            </tr>
                        </thead>
                        <tbody>
                            {census &&
                            selectedQuote &&
                            selectedQuote.length === 36 &&
                            censusEditMode ? (
                                <tr>
                                    <td
                                        colSpan={editableColSpan}
                                        className={css(
                                            styles.tableRow,
                                            styles.censusTableCellLink,
                                            styles.censusTableCellCenter,
                                            styles.redBar,
                                        )}
                                        onClick={this._addCensusMember}
                                    >
                                        Add Employee
                                    </td>
                                </tr>
                            ) : null}
                            {census && selectedQuote && !censusEditMode
                                ? census.map((c, index) => {
                                      return (
                                          <React.Fragment key={index}>
                                              <tr className={c.relationship === "EE" ? "" : "sub"}>
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          c.relationship === "EE"
                                                              ? styles.redBar
                                                              : styles.blueBar,
                                                      )}
                                                  >
                                                      {c.sequenceNumber}
                                                  </td>
                                                  {!censusEditMode && hasGeneralInfoCounty ? (
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tableCheckboxCell,
                                                          )}
                                                      >
                                                          {c.relationship === "EE" ? (
                                                              <Checkbox
                                                                  checked={
                                                                      !!worksheetSelectedRows[
                                                                          c.sequenceNumber
                                                                      ]
                                                                  }
                                                                  onChange={e =>
                                                                      this._toggleWorksheetRowSelection(
                                                                          c.sequenceNumber,
                                                                          e.target.checked,
                                                                      )
                                                                  }
                                                              />
                                                          ) : null}
                                                      </td>
                                                  ) : null}
                                                  <td className={css(styles.tableRow)}>
                                                      {c.relationship}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.fullName}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.birthDateString}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>{c.age}</td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.gender}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.medicalCoverage}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.dentalCoverage}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.visionCoverage}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.lifeCoverage}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.relationship === "EE"
                                                          ? c.homePostalCode
                                                          : this._getEmployeeHomeZipForRow(
                                                                census,
                                                                c,
                                                            )}
                                                  </td>
                                                  {c.relationship === "C" &&
                                                  (c.dependentType !== "Spouse" ||
                                                      !c.dependentType) ? (
                                                      <td
                                                          colSpan="3"
                                                          className={css(styles.tableRow)}
                                                      >
                                                          <div
                                                              className={css(
                                                                  styles.dependentStatusContainer,
                                                              )}
                                                          >
                                                              <span
                                                                  className={css(
                                                                      styles.dependentStatusLabel,
                                                                  )}
                                                              >
                                                                  Dependent Status
                                                              </span>
                                                              <span>
                                                                  {c.childDependentStatus ||
                                                                      "Child"}
                                                              </span>
                                                          </div>
                                                      </td>
                                                  ) : (
                                                      <React.Fragment>
                                                          <td className={css(styles.tableRow)}>
                                                              {c.workPostalCode}
                                                          </td>
                                                          <td className={css(styles.tableRow)}>
                                                              {c.occupation}
                                                          </td>
                                                          <td className={css(styles.tableRow)}>
                                                              {c.salary}
                                                          </td>
                                                      </React.Fragment>
                                                  )}
                                                  <td className={css(styles.tableRow)}>
                                                      {c.email}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.currentMedicalPlanName}
                                                      {parseFloat(c.currentMedicalCompositeRate)
                                                          ? " (Comp: $" +
                                                            parseFloat(
                                                                c.currentMedicalCompositeRate,
                                                            ).toFixed(2) +
                                                            ")"
                                                          : parseFloat(c.currentMedicalAgeRate)
                                                          ? " (Age: $" +
                                                            parseFloat(
                                                                c.currentMedicalAgeRate,
                                                            ).toFixed(2) +
                                                            ")"
                                                          : ""}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {c.relationship === "EE"
                                                          ? c.enrollmentDateString ||
                                                            c.enrollmentDate ||
                                                            ""
                                                          : ""}
                                                  </td>
                                                  {showPlanTypeColumns ? (
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          {c.relationship === "EE"
                                                              ? c.isPPO === null ||
                                                                c.isPPO === undefined ||
                                                                c.isPPO
                                                                  ? "Yes"
                                                                  : "No"
                                                              : ""}
                                                      </td>
                                                  ) : null}
                                                  {showPlanTypeColumns ? (
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          {c.relationship === "EE"
                                                              ? c.isHMO === null ||
                                                                c.isHMO === undefined ||
                                                                c.isHMO
                                                                  ? "Yes"
                                                                  : "No"
                                                              : ""}
                                                      </td>
                                                  ) : null}
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.tablePlanFlagCell,
                                                      )}
                                                  >
                                                      {c.relationship === "EE"
                                                          ? c.onCobra
                                                              ? "Yes"
                                                              : "No"
                                                          : ""}
                                                  </td>
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.tablePlanFlagCell,
                                                      )}
                                                  >
                                                      {c.relationship === "EE"
                                                          ? c.isTobacco
                                                              ? "Yes"
                                                              : "No"
                                                          : ""}
                                                  </td>
                                              </tr>
                                              {c.dependents.map((d, index2) => (
                                                  <tr key={index * 100 + index2} className="sub">
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.blueBar,
                                                          )}
                                                      >
                                                          {d.sequenceNumber}
                                                      </td>
                                                      {!censusEditMode && hasGeneralInfoCounty ? (
                                                          <td
                                                              className={css(
                                                                  styles.tableRow,
                                                                  styles.tableCheckboxCell,
                                                              )}
                                                          ></td>
                                                      ) : null}
                                                      <td className={css(styles.tableRow)}>
                                                          {d.relationship}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.fullName}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.birthDateString}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.age}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.gender}
                                                      </td>
                                                      <td
                                                          colSpan="4"
                                                          className={css(styles.tableRow)}
                                                      ></td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.homePostalCode}
                                                      </td>
                                                      <td
                                                          colSpan="3"
                                                          className={css(styles.tableRow)}
                                                      >
                                                          {d.dependentType !== "Spouse" ? (
                                                              <div
                                                                  className={css(
                                                                      styles.dependentStatusContainer,
                                                                  )}
                                                              >
                                                                  <span
                                                                      className={css(
                                                                          styles.dependentStatusLabel,
                                                                      )}
                                                                  >
                                                                      Dependent Status
                                                                  </span>
                                                                  <span>
                                                                      {d.childDependentStatus ||
                                                                          "Child"}
                                                                  </span>
                                                              </div>
                                                          ) : (
                                                              ""
                                                          )}
                                                      </td>
                                                      <td className={css(styles.tableRow)}></td>
                                                      <td className={css(styles.tableRow)}>
                                                          {d.currentMedicalPlanName}
                                                          {parseFloat(d.currentMedicalCompositeRate)
                                                              ? " (Comp: $" +
                                                                parseFloat(
                                                                    d.currentMedicalCompositeRate,
                                                                ).toFixed(2) +
                                                                ")"
                                                              : parseFloat(d.currentMedicalAgeRate)
                                                              ? " (Age: $" +
                                                                parseFloat(
                                                                    d.currentMedicalAgeRate,
                                                                ).toFixed(2) +
                                                                ")"
                                                              : ""}
                                                      </td>
                                                      <td className={css(styles.tableRow)}></td>
                                                      {showPlanTypeColumns ? (
                                                          <td className={css(styles.tableRow)}></td>
                                                      ) : null}
                                                      {showPlanTypeColumns ? (
                                                          <td className={css(styles.tableRow)}></td>
                                                      ) : null}
                                                      <td className={css(styles.tableRow)}></td>
                                                      <td className={css(styles.tableRow)}></td>
                                                  </tr>
                                              ))}
                                          </React.Fragment>
                                      );
                                  })
                                : census &&
                                  selectedQuote &&
                                  selectedQuote.length === 36 &&
                                  censusEditMode
                                ? census.map((cen, index) => {
                                      return (
                                          <React.Fragment key={index}>
                                              <tr>
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.redBar,
                                                      )}
                                                  >
                                                      {cen.sequenceNumber}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      {cen.relationship === "EE" ? (
                                                          cen.relationship
                                                      ) : (
                                                          <SmallDropdown
                                                              tabIndex={index * 100 + 0}
                                                              name={inputNames.relationship}
                                                              placeholder="- SP/C -"
                                                              options={this.state.relationship.map(
                                                                  o => ({
                                                                      label: o.name,
                                                                      value: o.name,
                                                                  }),
                                                              )}
                                                              onChange={e =>
                                                                  this._setRelationship(
                                                                      e,
                                                                      cen,
                                                                      null,
                                                                  )
                                                              }
                                                              value={
                                                                  cen.dependentType === "Spouse"
                                                                      ? "SP"
                                                                      : "C"
                                                              }
                                                          />
                                                      )}
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 1}
                                                          value={cen.firstName}
                                                          placeholder="- First -"
                                                          onChange={e =>
                                                              this._setFirstName(e, cen, null)
                                                          }
                                                          hideLabel={true}
                                                          size="small"
                                                          validationMessage={
                                                              !cen.firstName ? "*" : ""
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 2}
                                                          value={cen.lastName}
                                                          placeholder="- Last -"
                                                          onChange={e =>
                                                              this._setLastName(e, cen, null)
                                                          }
                                                          hideLabel={true}
                                                          size="small"
                                                          validationMessage={
                                                              !cen.lastName ? "*" : ""
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 3}
                                                          value={
                                                              cen.birthDate &&
                                                              cen.birthDate.length >= 10
                                                                  ? format(
                                                                        cen.birthDate,
                                                                        "MM/DD/YYYY",
                                                                    )
                                                                  : cen.birthDate
                                                                  ? cen.birthDate
                                                                  : ""
                                                          }
                                                          placeholder="- MM/DD/YYYY -"
                                                          onChange={e => this._setDOB(e, cen, null)}
                                                          hideLabel={true}
                                                          size="small"
                                                          validationMessage={
                                                              !cen.birthDate ||
                                                              cen.birthDate.length < 10
                                                                  ? "*"
                                                                  : ""
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <SmallDropdown
                                                          tabIndex={index * 100 + 4}
                                                          name={inputNames.gender}
                                                          placeholder="- M/F -"
                                                          options={this.state.gender.map(o => ({
                                                              label: o.name,
                                                              value: o.id,
                                                          }))}
                                                          onChange={e =>
                                                              this._setGender(e, cen, null)
                                                          }
                                                          value={cen.gender}
                                                          validationMessage={!cen.gender ? "*" : ""}
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <SmallDropdown
                                                          tabIndex={index * 100 + 5}
                                                          name={inputNames.medicalCoverage}
                                                          placeholder="- Med -"
                                                          options={this.state.coverage.map(o => ({
                                                              label: o.name,
                                                              value: o.id,
                                                          }))}
                                                          onChange={e =>
                                                              this._setMedicalCoverage(e, cen, null)
                                                          }
                                                          value={
                                                              cen.medicalCoverageId
                                                                  ? cen.medicalCoverageId.toString()
                                                                  : "1"
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <SmallDropdown
                                                          tabIndex={index * 100 + 6}
                                                          name={inputNames.dentalCoverage}
                                                          placeholder="- Den -"
                                                          options={this.state.coverage.map(o => ({
                                                              label: o.name,
                                                              value: o.id,
                                                          }))}
                                                          onChange={e =>
                                                              this._setDentalCoverage(e, cen, null)
                                                          }
                                                          value={
                                                              cen.dentalCoverageId
                                                                  ? cen.dentalCoverageId.toString()
                                                                  : "1"
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <SmallDropdown
                                                          tabIndex={index * 100 + 7}
                                                          name={inputNames.visionCoverage}
                                                          placeholder="- Vis -"
                                                          options={this.state.coverage.map(o => ({
                                                              label: o.name,
                                                              value: o.id,
                                                          }))}
                                                          onChange={e =>
                                                              this._setVisionCoverage(e, cen, null)
                                                          }
                                                          value={
                                                              cen.visionCoverageId
                                                                  ? cen.visionCoverageId.toString()
                                                                  : "1"
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <SmallDropdown
                                                          tabIndex={index * 100 + 8}
                                                          name={inputNames.lifeCoverage}
                                                          placeholder="- Lif -"
                                                          options={this.state.coverage2.map(o => ({
                                                              label: o.name,
                                                              value: o.id,
                                                          }))}
                                                          onChange={e =>
                                                              this._setLifeCoverage(e, cen, null)
                                                          }
                                                          value={
                                                              cen.lifeCoverageId
                                                                  ? cen.lifeCoverageId.toString()
                                                                  : "1"
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 9}
                                                          value={
                                                              cen.homePostalCode
                                                                  ? cen.homePostalCode
                                                                  : ""
                                                          }
                                                          placeholder="- 00000 -"
                                                          onChange={e =>
                                                              this._setHZip(e, cen, null)
                                                          }
                                                          hideLabel={true}
                                                          size="small"
                                                          validationMessage={
                                                              !cen.homePostalCode ||
                                                              cen.homePostalCode.length < 5
                                                                  ? "*"
                                                                  : ""
                                                          }
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 10}
                                                          value={
                                                              cen.workPostalCode
                                                                  ? cen.workPostalCode
                                                                  : ""
                                                          }
                                                          placeholder="- 00000 -"
                                                          onChange={e => this._setWZip(e, cen)}
                                                          hideLabel={true}
                                                          size="small"
                                                      />
                                                  </td>
                                                  {cen.relationship === "C" &&
                                                  (cen.dependentType !== "Spouse" ||
                                                      !cen.dependentType) ? (
                                                      <td
                                                          colSpan="3"
                                                          className={css(styles.tableRow)}
                                                      >
                                                          <div
                                                              className={css(
                                                                  styles.dependentStatusContainer,
                                                              )}
                                                          >
                                                              <span
                                                                  className={css(
                                                                      styles.dependentStatusLabel,
                                                                  )}
                                                              >
                                                                  Dependent Status
                                                              </span>
                                                              <SmallDropdown
                                                                  tabIndex={index * 100 + 11}
                                                                  name={
                                                                      inputNames.childDependentStatus
                                                                  }
                                                                  placeholder="- Status -"
                                                                  options={[
                                                                      {
                                                                          label: "Child",
                                                                          value: "Child",
                                                                      },
                                                                      {
                                                                          label: "Student",
                                                                          value: "Student",
                                                                      },
                                                                      {
                                                                          label: "Disabled",
                                                                          value: "Disabled",
                                                                      },
                                                                  ]}
                                                                  onChange={e =>
                                                                      this._setChildDependentStatus(
                                                                          e,
                                                                          cen,
                                                                          null,
                                                                      )
                                                                  }
                                                                  value={
                                                                      cen.childDependentStatus ||
                                                                      "Child"
                                                                  }
                                                              />
                                                          </div>
                                                      </td>
                                                  ) : (
                                                      <React.Fragment>
                                                          <td className={css(styles.tableRow)}>
                                                              <TextInput
                                                                  tabIndex={index * 100 + 11}
                                                                  value={
                                                                      cen.occupation
                                                                          ? cen.occupation
                                                                          : ""
                                                                  }
                                                                  placeholder="- Title -"
                                                                  onChange={e =>
                                                                      this._setOccupation(e, cen)
                                                                  }
                                                                  hideLabel={true}
                                                                  size="small"
                                                              />
                                                          </td>
                                                          <td className={css(styles.tableRow)}>
                                                              <TextInput
                                                                  tabIndex={index * 100 + 12}
                                                                  value={
                                                                      cen.salary ? cen.salary : ""
                                                                  }
                                                                  placeholder="- Salary -"
                                                                  onChange={e =>
                                                                      this._setSalary(e, cen)
                                                                  }
                                                                  hideLabel={true}
                                                                  size="small"
                                                              />
                                                          </td>
                                                      </React.Fragment>
                                                  )}
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 13}
                                                          value={cen.email ? cen.email : ""}
                                                          placeholder="- Email -"
                                                          onChange={e => this._setEmail(e, cen)}
                                                          hideLabel={true}
                                                          size="small"
                                                      />
                                                  </td>
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.tableRowWide,
                                                      )}
                                                  >
                                                      <SearchInput
                                                          tabIndex={index * 100 + 14}
                                                          search={searchApi.searchCurrentPlans}
                                                          onItemSelected={e =>
                                                              this._setCurrentPlan(e, cen)
                                                          }
                                                          placeholder={
                                                              cen.currentMedicalPlanId
                                                                  ? cen.currentMedicalPlanName
                                                                  : "Set Current Plan"
                                                          }
                                                          hideLabel={true}
                                                          type={searchInputTypes.textNoIconShort}
                                                          extraId={employer.id}
                                                      />
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <TextInput
                                                          tabIndex={index * 100 + 15}
                                                          value={
                                                              cen.enrollmentDate &&
                                                              cen.enrollmentDate.length >= 10
                                                                  ? format(
                                                                        cen.enrollmentDate,
                                                                        "MM/DD/YYYY",
                                                                    )
                                                                  : cen.enrollmentDate
                                                                  ? cen.enrollmentDate
                                                                  : ""
                                                          }
                                                          placeholder="- MM/DD/YYYY -"
                                                          onChange={e =>
                                                              this._setEnrollmentDate(e, cen)
                                                          }
                                                          hideLabel={true}
                                                          size="small"
                                                      />
                                                  </td>
                                                  {showPlanTypeColumns ? (
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          <label
                                                              className={css(
                                                                  styles.planFlagCheckLabel,
                                                              )}
                                                          >
                                                              <Checkbox
                                                                  tabIndex={index * 100 + 16}
                                                                  aStyles={styles.planFlagCheck}
                                                                  checked={
                                                                      cen.isPPO === null ||
                                                                      cen.isPPO === undefined ||
                                                                      cen.isPPO
                                                                  }
                                                                  name={inputNames.isPPO}
                                                                  onChange={e =>
                                                                      this._handleCensusCheckboxChange(
                                                                          e,
                                                                          cen,
                                                                      )
                                                                  }
                                                              />
                                                          </label>
                                                      </td>
                                                  ) : null}
                                                  {showPlanTypeColumns ? (
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          <label
                                                              className={css(
                                                                  styles.planFlagCheckLabel,
                                                              )}
                                                          >
                                                              <Checkbox
                                                                  tabIndex={index * 100 + 17}
                                                                  aStyles={styles.planFlagCheck}
                                                                  checked={
                                                                      cen.isHMO === null ||
                                                                      cen.isHMO === undefined ||
                                                                      cen.isHMO
                                                                  }
                                                                  name={inputNames.isHMO}
                                                                  onChange={e =>
                                                                      this._handleCensusCheckboxChange(
                                                                          e,
                                                                          cen,
                                                                      )
                                                                  }
                                                              />
                                                          </label>
                                                      </td>
                                                  ) : null}
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.tablePlanFlagCell,
                                                      )}
                                                  >
                                                      <label
                                                          className={css(
                                                              styles.planFlagCheckLabel,
                                                          )}
                                                      >
                                                          <Checkbox
                                                              tabIndex={index * 100 + 18}
                                                              aStyles={styles.planFlagCheck}
                                                              checked={!!cen.onCobra}
                                                              name={inputNames.onCobra}
                                                              onChange={e =>
                                                                  this._handleCensusCheckboxChange(
                                                                      e,
                                                                      cen,
                                                                  )
                                                              }
                                                          />
                                                      </label>
                                                  </td>
                                                  <td
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.tablePlanFlagCell,
                                                      )}
                                                  >
                                                      <label
                                                          className={css(
                                                              styles.planFlagCheckLabel,
                                                          )}
                                                      >
                                                          <Checkbox
                                                              tabIndex={index * 100 + 19}
                                                              aStyles={styles.planFlagCheck}
                                                              checked={!!cen.isTobacco}
                                                              name={inputNames.isTobacco}
                                                              onChange={e =>
                                                                  this._handleCensusCheckboxChange(
                                                                      e,
                                                                      cen,
                                                                  )
                                                              }
                                                          />
                                                      </label>
                                                  </td>
                                                  <td className={css(styles.tableRow)}>
                                                      <CancelIcon
                                                          className={css(styles.clearCensusButton)}
                                                          onClick={() =>
                                                              this._removeCensusMember(cen)
                                                          }
                                                      />
                                                  </td>
                                              </tr>
                                              {cen.dependents.map((dep, index2) => (
                                                  <tr key={index * 100 + index2} className="sub">
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.blueBar,
                                                          )}
                                                      >
                                                          {dep.sequenceNumber}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <SmallDropdown
                                                              tabIndex={
                                                                  index * 100 + index2 * 100 + 15
                                                              }
                                                              name={inputNames.relationship}
                                                              placeholder="- SP/C -"
                                                              options={this.state.relationship.map(
                                                                  o => ({
                                                                      label: o.name,
                                                                      value: o.name,
                                                                  }),
                                                              )}
                                                              onChange={e =>
                                                                  this._setRelationship(e, cen, dep)
                                                              }
                                                              value={
                                                                  dep.dependentType === "Spouse"
                                                                      ? "SP"
                                                                      : "C"
                                                              }
                                                              validationMessage={
                                                                  !dep.relationship ? "*" : ""
                                                              }
                                                          />
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <TextInput
                                                              tabIndex={
                                                                  index * 100 + index2 * 100 + 16
                                                              }
                                                              value={dep.firstName}
                                                              placeholder="- First -"
                                                              onChange={e =>
                                                                  this._setFirstName(e, cen, dep)
                                                              }
                                                              hideLabel={true}
                                                              size="small"
                                                              validationMessage={
                                                                  !dep.firstName ? "*" : ""
                                                              }
                                                          />
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <TextInput
                                                              tabIndex={
                                                                  index * 100 + index2 * 100 + 17
                                                              }
                                                              value={dep.lastName}
                                                              placeholder="- Last -"
                                                              onChange={e =>
                                                                  this._setLastName(e, cen, dep)
                                                              }
                                                              hideLabel={true}
                                                              size="small"
                                                              validationMessage={
                                                                  !dep.lastName ? "*" : ""
                                                              }
                                                          />
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <TextInput
                                                              tabIndex={
                                                                  index * 100 + index2 * 100 + 18
                                                              }
                                                              value={
                                                                  dep.birthDate &&
                                                                  dep.birthDate.length >= 10
                                                                      ? format(
                                                                            dep.birthDate,
                                                                            "MM/DD/YYYY",
                                                                        )
                                                                      : dep.birthDate
                                                                      ? dep.birthDate
                                                                      : ""
                                                              }
                                                              placeholder="- MM/DD/YYYY -"
                                                              onChange={e =>
                                                                  this._setDOB(e, cen, dep)
                                                              }
                                                              data-type="date"
                                                              hideLabel={true}
                                                              size="small"
                                                              validationMessage={
                                                                  !dep.birthDate ||
                                                                  dep.birthDate.length < 10
                                                                      ? "*"
                                                                      : ""
                                                              }
                                                          />
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <SmallDropdown
                                                              tabIndex={
                                                                  index * 100 + index2 * 100 + 19
                                                              }
                                                              name={inputNames.gender}
                                                              placeholder="- M/F -"
                                                              options={this.state.gender.map(o => ({
                                                                  label: o.name,
                                                                  value: o.id,
                                                              }))}
                                                              onChange={e =>
                                                                  this._setGender(e, cen, dep)
                                                              }
                                                              value={dep.gender}
                                                              validationMessage={
                                                                  !dep.gender ? "*" : ""
                                                              }
                                                          />
                                                      </td>
                                                      <td
                                                          colSpan="4"
                                                          className={css(styles.tableRow)}
                                                      >
                                                          {" "}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {ENABLE_DEPENDENT_ZIP_EDIT ? (
                                                              <TextInput
                                                                  tabIndex={
                                                                      index * 100 +
                                                                      index2 * 100 +
                                                                      20
                                                                  }
                                                                  value={
                                                                      dep.homePostalCode
                                                                          ? dep.homePostalCode
                                                                          : ""
                                                                  }
                                                                  placeholder="- 00000 -"
                                                                  onChange={e =>
                                                                      this._setHZip(e, cen, dep)
                                                                  }
                                                                  hideLabel={true}
                                                                  size="small"
                                                                  validationMessage={
                                                                      !dep.homePostalCode ||
                                                                      dep.homePostalCode.length < 5
                                                                          ? "*"
                                                                          : ""
                                                                  }
                                                              />
                                                          ) : (
                                                              <span>
                                                                  {cen.homePostalCode || ""}
                                                              </span>
                                                          )}
                                                      </td>
                                                      <td
                                                          colSpan="3"
                                                          className={css(styles.tableRow)}
                                                      >
                                                          {dep.dependentType !== "Spouse" ? (
                                                              <div
                                                                  className={css(
                                                                      styles.dependentStatusContainer,
                                                                  )}
                                                              >
                                                                  <span
                                                                      className={css(
                                                                          styles.dependentStatusLabel,
                                                                      )}
                                                                  >
                                                                      Dependent Status
                                                                  </span>
                                                                  <SmallDropdown
                                                                      tabIndex={
                                                                          index * 100 +
                                                                          index2 * 100 +
                                                                          22
                                                                      }
                                                                      name={
                                                                          inputNames.childDependentStatus
                                                                      }
                                                                      placeholder="- Status -"
                                                                      options={[
                                                                          {
                                                                              label: "Child",
                                                                              value: "Child",
                                                                          },
                                                                          {
                                                                              label: "Student",
                                                                              value: "Student",
                                                                          },
                                                                          {
                                                                              label: "Disabled",
                                                                              value: "Disabled",
                                                                          },
                                                                      ]}
                                                                      onChange={e =>
                                                                          this._setChildDependentStatus(
                                                                              e,
                                                                              cen,
                                                                              dep,
                                                                          )
                                                                      }
                                                                      value={
                                                                          dep.childDependentStatus ||
                                                                          "Child"
                                                                      }
                                                                  />
                                                              </div>
                                                          ) : (
                                                              " "
                                                          )}
                                                      </td>
                                                      <td className={css(styles.tableRow)}> </td>
                                                      <td className={css(styles.tableRow)}> </td>
                                                      <td className={css(styles.tableRow)}> </td>
                                                      {showPlanTypeColumns ? (
                                                          <td
                                                              className={css(
                                                                  styles.tableRow,
                                                                  styles.tablePlanFlagCell,
                                                              )}
                                                          >
                                                              {" "}
                                                          </td>
                                                      ) : null}
                                                      {showPlanTypeColumns ? (
                                                          <td
                                                              className={css(
                                                                  styles.tableRow,
                                                                  styles.tablePlanFlagCell,
                                                              )}
                                                          >
                                                              {" "}
                                                          </td>
                                                      ) : null}
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          {" "}
                                                      </td>
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tablePlanFlagCell,
                                                          )}
                                                      >
                                                          <label
                                                              className={css(
                                                                  styles.planFlagCheckLabel,
                                                              )}
                                                          >
                                                              <Checkbox
                                                                  tabIndex={
                                                                      index * 100 + index2 * 100 + 21
                                                                  }
                                                                  aStyles={styles.planFlagCheck}
                                                                  checked={!!dep.isTobacco}
                                                                  name={inputNames.isTobacco}
                                                                  onChange={e =>
                                                                      this._handleCensusCheckboxChange(
                                                                          e,
                                                                          cen,
                                                                          dep,
                                                                      )
                                                                  }
                                                              />
                                                          </label>
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          <CancelIcon
                                                              className={css(
                                                                  styles.clearCensusButton,
                                                              )}
                                                              onClick={() =>
                                                                  this._removeDependent(cen, dep)
                                                              }
                                                          />
                                                      </td>
                                                  </tr>
                                              ))}
                                              <tr>
                                                  <td
                                                      colSpan={editableColSpan}
                                                      className={css(
                                                          styles.tableRow,
                                                          styles.censusTableCellLink,
                                                          styles.censusTableCellRight,
                                                          styles.blueBar,
                                                      )}
                                                      onClick={() => this._addDependent(cen)}
                                                  >
                                                      Add Dependent
                                                  </td>
                                              </tr>
                                          </React.Fragment>
                                      );
                                  })
                                : null}
                            {census &&
                            selectedQuote &&
                            selectedQuote.length === 36 &&
                            censusEditMode ? (
                                <tr>
                                    <td
                                        colSpan={editableColSpan}
                                        className={css(
                                            styles.tableRow,
                                            styles.censusTableCellLink,
                                            styles.censusTableCellCenter,
                                            styles.redBar,
                                        )}
                                        onClick={this._addCensusMember}
                                    >
                                        Add Employee
                                    </td>
                                </tr>
                            ) : null}
                            <tr ref={this.censusBottomRef}>
                                <td colSpan={editableColSpan} style={{ height: 1 }} />
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    _handleOnSave = () => {
        const employerSaved = new Promise(resolve => {
            const { employer, counties, inputs, selectedCounty } = this.state;

            if (counties.length > 1 && !inputs[inputNames.countyId]) {
                this.setState(prevState => {
                    const errors = { ...prevState.errors };
                    errors[inputNames.countyId] = "required";
                    return { errors };
                });
                toast.warning(
                    "The multi-county zip code that you entered requires you to choose a county before proceeding.",
                    { toastId: 1 },
                );
                resolve(false);
                return;
            }

            Object.keys(inputNames).forEach(key => {
                employer[key] = this.state.inputs[key];
            });

            if (!employer.employerAddress) {
                employer.employerAddress = {};
            }

            const selectedCountyOption = counties.find(
                c => c.id.toString() === String(inputs[inputNames.countyId]),
            );
            const resolvedCountyName =
                (selectedCountyOption && selectedCountyOption.name) || selectedCounty || null;
            const resolvedCountyId = inputs[inputNames.countyId]
                ? parseInt(inputs[inputNames.countyId], 10)
                : null;

            const selectedStateOption = this.state.states.find(
                s => s.id.toString() === String(inputs[inputNames.stateId]),
            );
            const resolvedStateName = selectedStateOption
                ? selectedStateOption.name || selectedStateOption.longName
                : null;

            employer.stateId = inputs[inputNames.stateId] || null;
            employer.state = resolvedStateName;
            employer.vericredFipsCode = resolvedCountyId;
            employer.county = resolvedCountyName;
            employer.countyName = resolvedCountyName;
            employer.employerAddress.stateId = inputs[inputNames.stateId] || null;
            employer.employerAddress.state = resolvedStateName;
            employer.employerAddress.postalCode = inputs[inputNames.postalCode] || null;
            employer.employerAddress.countyId = null;
            employer.employerAddress.county = resolvedCountyName;
            employer.employerAddress.countyName = resolvedCountyName;

            employerApi
                .saveEmployer(employer)
                .then(response => {
                    this._employerLoaded(response);
                    resolve(true);
                })
                .catch(err => {
                    const { response } = err;
                    if (response && response.status === 400 && response.data.errors) {
                        const errors = [];
                        const validationErrors = response.data.errors;
                        let messages = "";
                        Object.keys(validationErrors).forEach(key => {
                            errors[key] = "required";
                            messages += validationErrors[key] + "\n";
                        });

                        this.setState({
                            errors,
                        });
                        toast.error(messages, { toastId: 1 });
                        resolve(false);
                    }
                });
        });

        return employerSaved;
    };

    _handleOnCancel = () => {
        const { employer } = this.state;

        this._employerLoaded(employer);
    };

    _renderGeneralInfo = () => {
        const { employer } = this.state;
        const { me } = this.props;

        return (
            <div className={css(styles.generalInfo)}>
                <Container>
                    <Row>
                        <Column large={4}>
                            <div className={css(styles.leftColumn)}>
                                <Headline aStyles={styles.title}>
                                    {strings.generalInformation}
                                </Headline>
                                <div>
                                    <div className={css(styles.checkboxContainer)}>
                                        <label className={css(styles.checkLabel)}>
                                            <Checkbox
                                                aStyles={styles.check}
                                                checked={this.state.inputs[inputNames.isVirgin]}
                                                name={inputNames.isVirgin}
                                                onChange={this._handleInputChange}
                                                disabled={me.isBroker || employer.deleted}
                                            />
                                            <span className={css(styles.labelText)}>
                                                {strings.isVirgin}
                                            </span>
                                        </label>
                                        <label className={css(styles.checkLabel)}>
                                            <Checkbox
                                                aStyles={styles.check}
                                                checked={this.state.inputs[inputNames.isTest]}
                                                name={inputNames.isTest}
                                                onChange={this._handleInputChange}
                                                disabled={me.isBroker || employer.deleted}
                                            />
                                            <span className={css(styles.labelText)}>
                                                {strings.isTest}
                                            </span>
                                        </label>
                                    </div>
                                    <InlineEdit
                                        headerLabel={strings.groupNameLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!me.isBroker && !employer.deleted}
                                    >
                                        <div edit>
                                            <TextInput
                                                name={inputNames.name}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.groupNamePlaceholder}
                                                required={true}
                                                validationMessage={
                                                    this.state.errors[inputNames.name]
                                                }
                                                value={this.state.inputs[inputNames.name]}
                                            />
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {this.state.inputs[inputNames.name]}
                                            </div>
                                        </div>
                                    </InlineEdit>
                                    <InlineEdit
                                        headerLabel={strings.groupContactLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!me.isBroker && !employer.deleted}
                                    >
                                        <div edit>
                                            <TextInput
                                                name={inputNames.contactName}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.contactNamePlaceholder}
                                                value={this.state.inputs[inputNames.contactName]}
                                            />
                                            <TextInput
                                                name={inputNames.phone}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.phonePlaceholder}
                                                value={this.state.inputs[inputNames.phone]}
                                            />
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {this.state.inputs[inputNames.contactName]}
                                                &nbsp;/&nbsp;
                                                {this.state.inputs[inputNames.phone]}
                                            </div>
                                        </div>
                                    </InlineEdit>
                                    <InlineEdit
                                        headerLabel={strings.addressLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!me.isBroker && !employer.deleted}
                                    >
                                        <div edit>
                                            <TextInput
                                                name={inputNames.street1}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.streetAddressPlaceholder}
                                                required={true}
                                                validationMessage={
                                                    this.state.errors[inputNames.street1]
                                                }
                                                value={this.state.inputs[inputNames.street1]}
                                            />
                                            <TextInput
                                                name={inputNames.street2}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.streetAddressPlaceholder}
                                                value={this.state.inputs[inputNames.street2]}
                                            />
                                            <TextInput
                                                name={inputNames.city}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.cityPlaceholder}
                                                required={true}
                                                validationMessage={
                                                    this.state.errors[inputNames.city]
                                                }
                                                value={this.state.inputs[inputNames.city]}
                                            />
                                            <Dropdown
                                                options={Object.keys(this.state.states).map(id => ({
                                                    label: this.state.states[id].longName,
                                                    value: this.state.states[id].id,
                                                }))}
                                                onChange={this._handleStateChange}
                                                placeholder={strings.statePlaceholder}
                                                value={this.state.inputs[inputNames.stateId]}
                                                validationMessage={
                                                    this.state.errors[inputNames.stateId]
                                                }
                                                hideLabel={true}
                                            />
                                            <TextInput
                                                name={inputNames.postalCode}
                                                onChange={this._handleTextChange}
                                                placeholder={strings.zipPlaceholder}
                                                required={true}
                                                validationMessage={
                                                    this.state.errors[inputNames.postalCode]
                                                }
                                                value={this.state.inputs[inputNames.postalCode]}
                                            />
                                            {this.state.counties.length > 1 && (
                                                <div>
                                                    <Dropdown
                                                        name={inputNames.countyId}
                                                        options={this.state.counties.map(item => ({
                                                            label:
                                                                item.ratingArea &&
                                                                item.ratingArea > 0
                                                                    ? item.name +
                                                                      " (Rating Area " +
                                                                      item.ratingArea.toString() +
                                                                      ")"
                                                                    : item.name,
                                                            value: item.id.toString(),
                                                        }))}
                                                        onChange={this._handleCountyIdChanged}
                                                        placeholder={strings.countyPlaceholder}
                                                        validationMessage={
                                                            this.state.errors[inputNames.countyId]
                                                        }
                                                        value={
                                                            this.state.inputs[inputNames.countyId]
                                                        }
                                                    />
                                                    <div className={css(styles.countyHelpText)}>
                                                        {strings.countyHelpText}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {this.state.inputs[inputNames.street1]}&nbsp;
                                                {this.state.inputs[inputNames.street2]}
                                            </div>
                                            <div className={css(styles.displayRow)}>
                                                {this.state.inputs[inputNames.city]},&nbsp;
                                                {this.state.stateText}&nbsp;
                                                {this.state.inputs[inputNames.postalCode]}
                                            </div>
                                            {(this.state.selectedCounty || employer.county) && (
                                                <div className={css(styles.displayRow)}>
                                                    {this.state.selectedCounty || employer.county}{" "}
                                                    County
                                                </div>
                                            )}
                                        </div>
                                    </InlineEdit>
                                    <InlineEdit
                                        headerLabel={strings.sicLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!me.isBroker && !employer.deleted}
                                    >
                                        <div edit>
                                            <SearchInput
                                                search={searchApi.searchSICCodes}
                                                onItemSelected={this._sicCodeSelected}
                                                placeholder={strings.sicPlaceholder}
                                                validationMessage={
                                                    this.state.errors[inputNames.sicCodeId]
                                                }
                                                required={true}
                                                value={employer.sicCode}
                                                type={searchInputTypes.textNoIcon}
                                            />
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {employer.sicCode}
                                            </div>
                                        </div>
                                    </InlineEdit>
                                    <InlineEdit
                                        headerLabel={strings.segmentSizeLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!me.isBroker && !employer.deleted}
                                    >
                                        <div edit>
                                            <Dropdown
                                                options={segmentSizes.map(seg => ({
                                                    label: seg.value,
                                                    value: seg.value,
                                                }))}
                                                onChange={this._handleSegmentSizeChange}
                                                placeholder={strings.segmentSizePlaceholder}
                                                value={this.state.inputs[inputNames.segmentSize]}
                                                validationMessage={
                                                    this.state.errors[inputNames.segmentSize]
                                                }
                                            />
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {this.state.inputs[inputNames.segmentSize]}
                                            </div>
                                        </div>
                                    </InlineEdit>
                                    <InlineEdit
                                        headerLabel={strings.payrollCycleLabel}
                                        onSave={this._handleOnSave}
                                        onCancel={this._handleOnCancel}
                                        editable={!employer.deleted}
                                    >
                                        <div edit>
                                            <div className={css(styles.dropdownEdit)}>
                                                <Dropdown
                                                    options={Object.keys(
                                                        this.state.payrollCycles,
                                                    ).map(id => ({
                                                        label: this.state.payrollCycles[id].name,
                                                        value: this.state.payrollCycles[id].id,
                                                    }))}
                                                    onChange={this._handlePayrollCycleChange}
                                                    placeholder={strings.payrollCyclePlaceholder}
                                                    value={
                                                        this.state.inputs[inputNames.payrollCycleId]
                                                    }
                                                    validationMessage={
                                                        this.state.errors[inputNames.payrollCycleId]
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div display>
                                            <div className={css(styles.displayRow)}>
                                                {employer.payrollCycle}
                                            </div>
                                        </div>
                                    </InlineEdit>
                                    <div className={css(styles.container)}>
                                        <div className={css(styles.headerLabel)}>
                                            {strings.alias}
                                        </div>
                                        <div className={css(styles.displayContainer)}>
                                            {this.state.inputs[inputNames.alias]}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Column>
                        <Column large={4}>
                            <div className={css(styles.centerColumn)}>
                                <Headline aStyles={styles.title}>
                                    {strings.salesAndService}
                                </Headline>
                                <InlineEdit
                                    headerLabel={strings.brokerLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <SearchInput
                                            search={searchApi.searchBrokers}
                                            onItemSelected={this._brokerSelected}
                                            placeholder={strings.brokerNamePlaceholder}
                                            aStyles={styles.brokerSearch}
                                            type={searchInputTypes.text}
                                            value={employer.brokerName}
                                            validationMessage={
                                                this.state.errors[inputNames.brokerId]
                                            }
                                            hideLabel={true}
                                        />
                                    </div>
                                    <div display>
                                        <div
                                            className={css(styles.displayRow, styles.link)}
                                            onClick={() =>
                                                this._goToBroker(
                                                    employer.broker ? employer.broker.id : 0,
                                                )
                                            }
                                        >
                                            {employer.brokerName}
                                        </div>
                                        {employer.broker && (
                                            <React.Fragment>
                                                <div className={css(styles.displayRow)}>
                                                    Phone: {employer.broker.phone}
                                                </div>
                                                <div className={css(styles.displayRow)}>
                                                    Email: {employer.broker.emailAddress}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.salesRepresentativeLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <div className={css(styles.dropdownEdit)}>
                                            <Dropdown
                                                options={Object.keys(this.state.newHireUsers).map(
                                                    id => ({
                                                        label:
                                                            this.state.newHireUsers[id].lastName +
                                                            ", " +
                                                            this.state.newHireUsers[id].firstName,
                                                        value: this.state.newHireUsers[id].id,
                                                    }),
                                                )}
                                                onChange={this._handleSalesRepresentativeChange}
                                                placeholder={strings.salesRepresentativePlaceholder}
                                                value={
                                                    this.state.inputs[
                                                        inputNames.salesRepresentativeId
                                                    ]
                                                }
                                                hideLabel={true}
                                                validationMessage={
                                                    this.state.errors[
                                                        inputNames.salesRepresentativeId
                                                    ]
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {this.state.salesRepresentative}
                                        </div>
                                        {employer.salesRepresentative && (
                                            <div className={css(styles.displayRow)}>
                                                Email: {employer.salesRepresentative.email}
                                            </div>
                                        )}
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.specialSalesRepresentativeLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <div className={css(styles.dropdownEdit)}>
                                            <Dropdown
                                                options={Object.keys(this.state.newHireUsers).map(
                                                    id => ({
                                                        label:
                                                            this.state.newHireUsers[id].lastName +
                                                            ", " +
                                                            this.state.newHireUsers[id].firstName,
                                                        value: this.state.newHireUsers[id].id,
                                                    }),
                                                )}
                                                onChange={
                                                    this._handleSpecialSalesRepresentativeChange
                                                }
                                                placeholder={
                                                    strings.specialSalesRepresentativePlaceholder
                                                }
                                                value={
                                                    this.state.inputs[
                                                        inputNames.specialSalesRepresentativeId
                                                    ]
                                                }
                                                hideLabel={true}
                                                validationMessage={
                                                    this.state.errors[
                                                        inputNames.specialSalesRepresentativeId
                                                    ]
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {this.state.specialSalesRepresentative}
                                        </div>
                                        {employer.specialSalesRepresentative && (
                                            <div className={css(styles.displayRow)}>
                                                Email: {employer.specialSalesRepresentative.email}
                                            </div>
                                        )}
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.renewalRepresentativeLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <div className={css(styles.dropdownEdit)}>
                                            <Dropdown
                                                options={Object.keys(this.state.newHireUsers).map(
                                                    id => ({
                                                        label:
                                                            this.state.newHireUsers[id].lastName +
                                                            ", " +
                                                            this.state.newHireUsers[id].firstName,
                                                        value: this.state.newHireUsers[id].id,
                                                    }),
                                                )}
                                                onChange={this._handleRenewalRepresentativeChange}
                                                placeholder={
                                                    strings.renewalRepresentativePlaceholder
                                                }
                                                value={
                                                    this.state.inputs[
                                                        inputNames.renewalRepresentativeId
                                                    ]
                                                }
                                                hideLabel={true}
                                                validationMessage={
                                                    this.state.errors[
                                                        inputNames.renewalRepresentativeId
                                                    ]
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {this.state.renewalRepresentative}
                                        </div>
                                        {employer.renewalRepresentative && (
                                            <div className={css(styles.displayRow)}>
                                                Email: {employer.renewalRepresentative.email}
                                            </div>
                                        )}
                                    </div>
                                </InlineEdit>
                            </div>
                        </Column>
                        <Column large={4}>
                            <div className={css(styles.rightColumn)}>
                                <Headline aStyles={styles.title}>{strings.details}</Headline>
                                {employer.currentMedicalPlans && (
                                    <div className={css(styles.containerScroll)}>
                                        <div className={css(styles.headerLabel)}>
                                            {strings.currentMedicalPlans}
                                        </div>
                                        <div className={css(styles.displayContainer)}>
                                            {employer.currentMedicalPlans}
                                        </div>
                                    </div>
                                )}
                                <InlineEdit
                                    headerLabel={strings.medicalRenewalDateLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <DatePicker
                                            name={inputNames.medicalRenewalDate}
                                            onChange={this._handleDateChange}
                                            placeholder={strings.medicalRenewalDatePlaceholder}
                                            value={this.state.inputs[inputNames.medicalRenewalDate]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.medicalRenewalDate
                                                ? format(employer.medicalRenewalDate, "MM/DD/YYYY")
                                                : null}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.medicalEffectiveDateLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <DatePicker
                                            name={inputNames.medicalEffectiveDate}
                                            onChange={this._handleDateChange}
                                            placeholder={strings.medicalEffectiveDatePlaceholder}
                                            value={
                                                this.state.inputs[inputNames.medicalEffectiveDate]
                                            }
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.medicalEffectiveDate
                                                ? format(
                                                      employer.medicalEffectiveDate,
                                                      "MM/DD/YYYY",
                                                  )
                                                : null}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.existingClientLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <Dropdown
                                            name={inputNames.isExistingClient}
                                            options={yesNoOptions}
                                            onChange={this._handleYesNoChanged}
                                            placeholder={strings.isExistingClientPlaceholder}
                                            value={this.state.inputs[inputNames.isExistingClient]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.isExistingClient ? "Yes" : "No"}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.cobraStatusLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <Dropdown
                                            name={inputNames.isCobra}
                                            options={yesNoOptions}
                                            onChange={this._handleYesNoChanged}
                                            placeholder={strings.isCobraPlaceholder}
                                            value={this.state.inputs[inputNames.isCobra]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.isCobra ? "Yes" : "No"}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.medicalLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <TextInput
                                            name={inputNames.medicalPriorCarrier}
                                            onChange={this._handleTextChange}
                                            placeholder={strings.medicalPriorCarrierPlaceholder}
                                            value={
                                                this.state.inputs[inputNames.medicalPriorCarrier]
                                            }
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.medicalPriorCarrier}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.dentalLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <TextInput
                                            name={inputNames.dentalPriorCarrier}
                                            onChange={this._handleTextChange}
                                            placeholder={strings.dentalPriorCarrierPlaceholder}
                                            value={this.state.inputs[inputNames.dentalPriorCarrier]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.dentalPriorCarrier}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.visionLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <TextInput
                                            name={inputNames.visionPriorCarrier}
                                            onChange={this._handleTextChange}
                                            placeholder={strings.visionPriorCarrierPlaceholder}
                                            value={this.state.inputs[inputNames.visionPriorCarrier]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.visionPriorCarrier}
                                        </div>
                                    </div>
                                </InlineEdit>
                                <InlineEdit
                                    headerLabel={strings.lifeLabel}
                                    onSave={this._handleOnSave}
                                    onCancel={this._handleOnCancel}
                                    editable={!me.isBroker && !employer.deleted}
                                >
                                    <div edit>
                                        <TextInput
                                            name={inputNames.lifePriorCarrier}
                                            onChange={this._handleTextChange}
                                            placeholder={strings.lifePriorCarrierPlaceholder}
                                            value={this.state.inputs[inputNames.lifePriorCarrier]}
                                        />
                                    </div>
                                    <div display>
                                        <div className={css(styles.displayRow)}>
                                            {employer.lifePriorCarrier}
                                        </div>
                                    </div>
                                </InlineEdit>
                            </div>
                        </Column>
                    </Row>
                </Container>
            </div>
        );
    };

    _addNote = () => {
        this.setState(prevState => {
            return {
                inputs: {
                    ...prevState.inputs,
                    [inputNames.note]: "",
                },
                showNewNoteModal: true,
            };
        });
    };

    _addQuote = () => {
        window.location.href = "/quotes/edit?g=" + this.props.match.params.id;
    };

    _openCensusModal = () => {
        this.setState({
            censusUpload: null,
            showUploadCensusModal: true,
        });
    };

    _censusFileSelected = file => {
        //check for xlsx
        const nm = file.name;
        const tp = file.type;
        if (
            !nm.endsWith(".xlsx") ||
            tp !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
            alert("Please use a valid Excel (.xlsx) template");
            return;
        }
        //continue
        this.setState({ censusUpload: file });
    };

    _cancelCensusClicked = () => {
        this.setState({
            censusUpload: null,
            isSubmittingCensus: false,
        });
    };

    _censusDropped = droppedFiles => {
        //check for xls
        const nm = droppedFiles[0].name;
        const tp = droppedFiles[0].type;
        if (
            !nm.endsWith(".xlsx") ||
            tp !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
            alert("Please use a valid Excel (.xlsx) template");
            return;
        }
        //continue
        this.setState({ censusUpload: droppedFiles[0] });
    };

    _uploadCensus = () => {
        const employerId = this.props.match.params.id;
        const { censusUpload, uniqueIds } = this.state;
        const guid = crypto.randomUUID();

        this.setState({ isSubmittingCensus: true });
        censusApi.uploadCensus(0, employerId, guid, censusUpload, null).then(response => {
            if (response.success) {
                //new census saved
                uniqueIds.push({ guid, createDate: "Today" });
                censusApi
                    .getCensusByUniqueId(employerId, guid)
                    .then(response2 => {
                        this.setState({
                            uniqueIds,
                            selectedQuote: guid.toLowerCase(),
                            census: this._normalizeCensusRows(response2),
                            currentCensus: response2.length + 1,
                        });
                    })
                    .catch(err => logger.log(err));
                //reset page
                this.setState({
                    showUploadCensusModal: false,
                    censusUpload: null,
                    isSubmittingCensus: false,
                });
                toast.success(response.message, { toastId: 1 });
            } else {
                //There was an error during upload...
                if (response && response.message) {
                    toast.error(
                        "There were some problems with your census.  Please fix and resubmit.",
                        { toastId: 2 },
                    );
                } else if (response && response.data) {
                    toast.error(response.data, { toastId: 2 });
                }
                this.setState({
                    censusUpload: null,
                    isSubmittingCensus: false,
                });
            }
        });
    };

    _copyCensus = () => {
        const { uniqueIds, selectedQuote } = this.state;

        //if editing an existing "editable" census
        if (selectedQuote.length === 36) {
            this.setState({ censusEditMode: true });
            return;
        }

        //else... create a copy and put into edit mode
        const guid = crypto.randomUUID();

        this.setState({ isSubmittingCensus: true });
        censusApi.copyCensus(selectedQuote, 0, guid).then(response => {
            if (response.success) {
                //We don't save at the "copy" point...  we ask the user to confirm the census.
                if (response && response.census) {
                    uniqueIds.push({ guid, createDate: "Today" });
                    this.setState({
                        uniqueIds,
                        selectedQuote: guid,
                        census: this._normalizeCensusRows(response.census),
                        currentCensus: response.census.length + 1,
                        censusEditMode: true,
                    });
                }
                this.setState({ isSubmittingCensus: false });
                toast.success(
                    "Census has been copied and is editable.  You must save this page to create the new Census record.",
                    { toastId: 1 },
                );
            } else {
                if (response && response.message) {
                    toast.error(response.message, { toastId: 3 });
                } else if (response && response.data) {
                    toast.error(response.data, { toastId: 3 });
                }
                this.setState({ isSubmittingCensus: false });
            }
        });
    };

    _saveCensus = () => {
        const employerId = this.props.match.params.id;
        //validate that the census is filled in...
        const { census, selectedQuote, quotes } = this.state;
        if (census && census.length > 0) {
            let cnt = 1;
            let err = false;
            let effDate = new Date(census[0].createDate);
            if (effDate.getFullYear() === 1) {
                effDate = new Date();
            }
            census.forEach(cen => {
                //have values for each field...  cen.homePostalCode === null ||
                if (
                    cen.sequenceNumber === null ||
                    cen.firstName === null ||
                    cen.lastName === null ||
                    cen.firstName.length === 0 ||
                    cen.lastName.length === 0 ||
                    cen.birthDate === null ||
                    cen.gender === null ||
                    cen.medicalCoverageId === null ||
                    cen.dentalCoverageId === null ||
                    cen.visionCoverageId === null ||
                    cen.lifeCoverageId === null ||
                    cen.homePostalCode === null ||
                    cen.homePostalCode.length === 0 ||
                    cen.isTobacco === null ||
                    cen.onCobra === null
                ) {
                    err = true;
                    toast.error(
                        "No. " + cen.sequenceNumber + ": Cannot submit an incomplete employee row.",
                        { toastId: cnt * 1 },
                    );
                }
                cen.fullName = cen.firstName + " " + cen.lastName;
                //check specific values for accuracy
                //DOB
                const censusBirthDate = new Date(cen.birthDate);
                if (
                    cen.birthDate.length < 10 ||
                    !(censusBirthDate instanceof Date) ||
                    isNaN(censusBirthDate.valueOf())
                ) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid DOB.", {
                        toastId: cnt * 10,
                    });
                }
                //Age
                cen.age = effDate.getFullYear() - censusBirthDate.getFullYear();
                if (
                    effDate < censusBirthDate.getMonth() ||
                    (effDate === censusBirthDate.getMonth() &&
                        effDate.getDate() < censusBirthDate.getDate())
                ) {
                    cen.age--;
                }
                //H Zip
                if (!/^\d{5}$/.test(cen.homePostalCode)) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid H Zip.", {
                        toastId: cnt * 20,
                    });
                }
                //W Zip
                if (
                    cen.workPostalCode !== null &&
                    cen.workPostalCode.length > 0 &&
                    !/^\d{5}$/.test(cen.workPostalCode)
                ) {
                    err = true;
                    toast.error("No. " + cen.sequenceNumber + ": Cannot submit an invalid W Zip.", {
                        toastId: cnt * 30,
                    });
                }
                //dependent rows
                if (cen.dependents && cen.dependents.length > 0) {
                    cen.dependents.forEach(dep => {
                        dep.fullName = dep.firstName + " " + dep.lastName;
                        //have values for each field...
                        if (
                            dep.sequenceNumber === null ||
                            dep.firstName === null ||
                            dep.lastName === null ||
                            dep.firstName.length === 0 ||
                            dep.lastName.length === 0 ||
                            dep.birthDate === null ||
                            dep.gender === null ||
                            dep.homePostalCode === null ||
                            dep.homePostalCode.length === 0 ||
                            dep.isTobacco === null ||
                            dep.onCobra === null
                        ) {
                            err = true;
                            toast.error(
                                "No. " +
                                    dep.sequenceNumber +
                                    ": Cannot submit an incomplete dependent row.",
                                { toastId: cnt * 40 },
                            );
                        }
                        //check specific values for accuracy
                        //DOB
                        let d = new Date(dep.birthDate);
                        if (
                            dep.birthDate.length < 5 ||
                            !(d instanceof Date) ||
                            isNaN(d.valueOf())
                        ) {
                            err = true;
                            toast.error(
                                "No. " + dep.sequenceNumber + ": Cannot submit an invalid DOB.",
                                { toastId: cnt * 50 },
                            );
                        }
                        //Age
                        dep.age = effDate.getFullYear() - d.getFullYear();
                        if (
                            effDate < d.getMonth() ||
                            (effDate === d.getMonth() && effDate.getDate() < d.getDate())
                        ) {
                            dep.age--;
                        }
                        //H Zip
                        if (!/^\d{5}$/.test(dep.homePostalCode)) {
                            err = true;
                            toast.error(
                                "No. " + dep.sequenceNumber + ": Cannot submit an invalid H Zip.",
                                { toastId: cnt * 60 },
                            );
                        }
                    });
                }
                //increment
                cnt++;
            });

            //passed?
            if (!err) {
                this.setState({ isSubmittingCensus: true });
                //save
                censusApi
                    .uploadCensus(0, employerId, selectedQuote, null, census)
                    .then(response => {
                        if (response.success) {
                            this.setState({
                                isSubmittingCensus: false,
                                censusEditMode: false,
                            });
                            toast.success("Census has been saved.", { toastId: 1 });
                        } else {
                            //There was an error during upload...
                            if (response && response.message) {
                                toast.error(
                                    "There were some problems with your census.  Please fix and resubmit.",
                                    { toastId: 2 },
                                );
                            } else if (response && response.data) {
                                toast.error(response.data, { toastId: 2 });
                            }
                            this.setState({
                                isSubmittingCensus: false,
                                censusEditMode: false,
                            });
                        }
                    });
            }
        } else {
            toast.error("Cannot submit an incomplete census.", { toastId: 1 });
        }
    };

    _saveNote = () => {
        employerApi
            .saveNote({
                note: this.state.inputs[inputNames.note],
                employerId: this.props.match.params.id,
            })
            .then(response => {
                this.setState({
                    showNewNoteModal: false,
                    notes: response,
                });
            });
    };

    _handleTabChanged = currentTab => {
        this.setState({ currentTab });
    };

    _handleShowModalAge = () => {
        const { inputs, employer } = this.state;
        const worksheetRenewalDate =
            inputs[inputNames.medicalRenewalDate] || employer.medicalRenewalDate || null;
        const worksheetFrequency = inputs[inputNames.payrollCycleId] || "";

        this.setState(
            {
                showModalAge: true,
                worksheetRenewalDate,
                worksheetRatingArea: "",
                worksheetFrequency,
                worksheetApplyRolloverBalanceToDependents: true,
                worksheetCarrier: "",
                worksheetBaseCarrier: "",
                worksheetBasePlan: "",
                worksheetBasePlanName: "",
                worksheetHasBasePlan: false,
                worksheetSelectedPlans: [],
                worksheetPossiblePlans: [],
                worksheetPossiblePlansFilter: "",
                showWorksheetPossiblePlansFilter: false,
                worksheetRenewalCarriers: [],
                worksheetRenewalPlans: [],
            },
            () => {
                this._loadWorksheetRatingArea();
                if (worksheetRenewalDate) {
                    this._handleWorksheetDateChange(worksheetRenewalDate, "worksheetRenewalDate");
                }
            },
        );
    };

    _handleHideModalAge = () => {
        this.setState({ showModalAge: false });
    };

    _handleWorksheetInputChange = e => {
        const { name, type, checked, value } = e.target;
        this.setState({ [name]: type === "checkbox" ? checked : value });
    };

    _handleWorksheetDateChange = (value, name) => {
        this.setState({ [name]: value }, () => {
            if (name === "worksheetRenewalDate") {
                this.setState(
                    {
                        worksheetCarrier: "",
                        worksheetBaseCarrier: "",
                        worksheetBasePlan: "",
                        worksheetBasePlanName: "",
                        worksheetHasBasePlan: false,
                        worksheetSelectedPlans: [],
                        worksheetPossiblePlans: [],
                        worksheetPossiblePlansFilter: "",
                        worksheetRenewalCarriers: [],
                        worksheetRenewalPlans: [],
                    },
                    () => {
                        this._loadWorksheetRenewalAgeRatedPlans(value);
                    },
                );
            }
        });
    };

    _handleWorksheetCarrierChange = value => {
        this.setState(
            {
                worksheetCarrier: value,
                worksheetPossiblePlansFilter: "",
            },
            () => {
                this._loadWorksheetPossiblePlans(value);
            },
        );
    };

    _handleWorksheetPossiblePlansFilterChange = e => {
        const term = e.target.value;
        this.setState({ worksheetPossiblePlansFilter: term }, () => {
            const { worksheetCarrier, worksheetRenewalPlans } = this.state;
            if (worksheetCarrier && worksheetRenewalPlans.length > 0) {
                this._loadWorksheetPossiblePlans(worksheetCarrier, term);
            }
        });
    };

    _toggleWorksheetPossiblePlansFilter = () => {
        this.setState(prevState => ({
            showWorksheetPossiblePlansFilter: !prevState.showWorksheetPossiblePlansFilter,
        }));
    };

    _formatWorksheetDateForApi = dateValue => {
        if (!dateValue) {
            return "";
        }

        let parsed = dateValue instanceof Date ? dateValue : new Date(dateValue);

        if (isNaN(parsed.valueOf()) && typeof dateValue === "string") {
            const match = dateValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (match) {
                const month = Number(match[1]);
                const day = Number(match[2]);
                const year = Number(match[3]);
                parsed = new Date(year, month - 1, day);
            }
        }

        if (isNaN(parsed.valueOf())) {
            return "";
        }

        return format(parsed, "YYYY-MM-DD");
    };

    _normalizeWorksheetRenewalPayload = payload => {
        const raw = payload || {};
        const responseObject = Array.isArray(raw)
            ? { plans: raw }
            : raw.data && typeof raw.data === "object"
            ? raw.data
            : raw;

        let carriers = responseObject.carriers || responseObject.eligibleCarriers || [];
        let plans =
            responseObject.plans ||
            responseObject.possiblePlans ||
            responseObject.medicalPlans ||
            [];

        if (!Array.isArray(plans)) {
            plans = [];
        }

        if (!Array.isArray(carriers)) {
            carriers = [];
        }

        if (plans.length === 0 && carriers.length > 0) {
            plans = carriers.reduce((acc, carrier) => {
                const nestedPlans = carrier.plans || carrier.medicalPlans || [];
                if (Array.isArray(nestedPlans)) {
                    return acc.concat(nestedPlans);
                }
                return acc;
            }, []);
        }

        if (carriers.length === 0 && plans.length > 0) {
            const uniqueCarrierMap = {};
            plans.forEach(plan => {
                const carrierId = plan.carrierId || plan.currentMedicalCarrierId || plan.parentId;
                const carrierName = plan.carrierName || plan.carrier || plan.type || "";
                if (carrierId || carrierName) {
                    const key = String(carrierId || carrierName);
                    if (!uniqueCarrierMap[key]) {
                        uniqueCarrierMap[key] = {
                            id: carrierId || carrierName,
                            name: carrierName,
                        };
                    }
                }
            });
            carriers = Object.keys(uniqueCarrierMap).map(key => uniqueCarrierMap[key]);
        }

        return {
            carriers,
            plans,
        };
    };

    _loadWorksheetRenewalAgeRatedPlans = renewalDateValue => {
        const { employer } = this.state;
        const formattedRenewalDate = this._formatWorksheetDateForApi(renewalDateValue);

        if (!formattedRenewalDate || !employer || !employer.id) {
            this.setState({
                worksheetRenewalCarriers: [],
                worksheetRenewalPlans: [],
                worksheetPossiblePlans: [],
            });
            return Promise.resolve();
        }

        this.setState({ worksheetPossiblePlansLoading: true });

        return searchApi
            .searchRenewalAgeRatedPlans(formattedRenewalDate, employer.id)
            .then(response => {
                const normalized = this._normalizeWorksheetRenewalPayload(response);
                const selectedCarrierId =
                    this.state.worksheetCarrier ||
                    (normalized.carriers[0] &&
                        (normalized.carriers[0].id || normalized.carriers[0].value)) ||
                    "";

                this.setState(
                    {
                        worksheetRenewalCarriers: normalized.carriers,
                        worksheetRenewalPlans: normalized.plans,
                        worksheetCarrier: selectedCarrierId,
                        worksheetPossiblePlansLoading: false,
                    },
                    () => {
                        if (selectedCarrierId) {
                            this._loadWorksheetPossiblePlans(selectedCarrierId);
                        } else {
                            this.setState({ worksheetPossiblePlans: [] });
                        }
                    },
                );
            })
            .catch(() => {
                this.setState({
                    worksheetRenewalCarriers: [],
                    worksheetRenewalPlans: [],
                    worksheetPossiblePlans: [],
                    worksheetPossiblePlansLoading: false,
                });
            });
    };

    _getWorksheetSelectedPlanIdsFromSettings = settings => {
        if (!settings || typeof settings !== "object") {
            return [];
        }

        const rawIds = settings.medicalPlanIDs || [];

        let ids = [];

        if (typeof rawIds === "string") {
            ids = rawIds
                .split(",")
                .map(id => id && id.toString().trim())
                .filter(Boolean);
        } else if (Array.isArray(rawIds)) {
            ids = rawIds
                .map(item => {
                    if (item === null || item === undefined) {
                        return "";
                    }
                    if (typeof item === "object") {
                        return item.id || item.value || item.planID || item.planId || "";
                    }
                    return item;
                })
                .map(id => id && id.toString().trim())
                .filter(Boolean);
        }

        return Array.from(new Set(ids));
    };

    _getWorksheetCarrierIdForPlan = (plan, renewalCarriers) => {
        if (!plan) {
            return "";
        }

        const directCarrierId = plan.carrierId || plan.currentMedicalCarrierId || plan.parentId;
        if (directCarrierId) {
            return String(directCarrierId);
        }

        const planCarrierName = (plan.carrierName || plan.carrier || plan.type || "")
            .toString()
            .toLowerCase();

        if (!planCarrierName) {
            return "";
        }

        const matchedCarrier = (renewalCarriers || []).find(carrier => {
            const carrierName = ((carrier && carrier.name) || "").toString().toLowerCase();
            return carrierName && carrierName === planCarrierName;
        });

        return matchedCarrier ? String(matchedCarrier.id || matchedCarrier.value || "") : "";
    };

    _applyWorksheetSelectedPlansFromIds = (selectedPlanIds, basePlanId = null) => {
        const selectedIdSet = new Set((selectedPlanIds || []).map(id => String(id)));

        this.setState(
            prevState => {
                const renewalPlans = prevState.worksheetRenewalPlans || [];
                const renewalCarriers = prevState.worksheetRenewalCarriers || [];

                const matchedPlans =
                    selectedIdSet.size === 0
                        ? []
                        : renewalPlans.filter(plan => {
                              const planId = plan.id || plan.value;
                              return planId && selectedIdSet.has(String(planId));
                          });

                const basePlanMatch =
                    basePlanId !== null
                        ? renewalPlans.find(
                              plan => String(plan.id || plan.value) === String(basePlanId),
                          )
                        : null;

                const nextState = { worksheetSelectedPlans: matchedPlans };
                const selectedPlanCarrierId = this._getWorksheetCarrierIdForPlan(
                    matchedPlans[0],
                    renewalCarriers,
                );
                const basePlanCarrierId = this._getWorksheetCarrierIdForPlan(
                    basePlanMatch,
                    renewalCarriers,
                );

                if (selectedPlanCarrierId) {
                    nextState.worksheetCarrier = selectedPlanCarrierId;
                } else if (basePlanCarrierId) {
                    nextState.worksheetCarrier = basePlanCarrierId;
                }

                nextState.worksheetHasBasePlan = !!basePlanMatch;

                if (basePlanMatch) {
                    nextState.worksheetBasePlan = String(basePlanMatch.id || basePlanMatch.value);
                    nextState.worksheetBasePlanName =
                        basePlanMatch.displayName ||
                        basePlanMatch.name ||
                        basePlanMatch.label ||
                        "";
                }

                if (basePlanCarrierId) {
                    nextState.worksheetBaseCarrier = basePlanCarrierId;
                }
                return nextState;
            },
            () => {
                const { worksheetCarrier, worksheetPossiblePlansFilter } = this.state;
                if (worksheetCarrier) {
                    this._loadWorksheetPossiblePlans(
                        worksheetCarrier,
                        worksheetPossiblePlansFilter,
                    );
                } else {
                    this.setState({ worksheetPossiblePlans: [] });
                }
            },
        );
    };

    _handleWorksheetSelectPlan = selectedPlanId => {
        this.setState(prevState => {
            const selectedPlanIndex = prevState.worksheetPossiblePlans.findIndex(
                plan => String(plan.id || plan.value) === String(selectedPlanId),
            );
            if (selectedPlanIndex < 0) {
                return null;
            }

            const selectedPlan = prevState.worksheetPossiblePlans[selectedPlanIndex];
            return {
                worksheetPossiblePlans: prevState.worksheetPossiblePlans.filter(
                    plan => String(plan.id || plan.value) !== String(selectedPlanId),
                ),
                worksheetSelectedPlans: [...prevState.worksheetSelectedPlans, selectedPlan],
            };
        });
    };

    _handleWorksheetRemovePlan = selectedPlanId => {
        this.setState(
            prevState => {
                const removedPlanIndex = prevState.worksheetSelectedPlans.findIndex(
                    plan => String(plan.id || plan.value) === String(selectedPlanId),
                );
                if (removedPlanIndex < 0) {
                    return null;
                }

                return {
                    worksheetSelectedPlans: prevState.worksheetSelectedPlans.filter(
                        plan => String(plan.id || plan.value) !== String(selectedPlanId),
                    ),
                };
            },
            () => {
                const { worksheetCarrier, worksheetPossiblePlansFilter } = this.state;
                if (worksheetCarrier) {
                    this._loadWorksheetPossiblePlans(
                        worksheetCarrier,
                        worksheetPossiblePlansFilter,
                    );
                }
            },
        );
    };

    _getWorksheetRatingArea = () => {
        const { employer, inputs } = this.state;
        const address = employer && employer.employerAddress ? employer.employerAddress : null;
        const postalCode = (address && address.postalCode) || inputs[inputNames.postalCode] || "";

        if (!postalCode || postalCode.toString().length !== 5) {
            return Promise.resolve(null);
        }

        return employerApi
            .checkZip(postalCode, "-1")
            .then(response => {
                if (!response || !response.message) {
                    return null;
                }

                const parseRatingAreaFromJson = rawJson => {
                    try {
                        const parsed = JSON.parse(rawJson);
                        return parsed && parsed[0] && parsed[0].ratingArea > 0
                            ? parsed[0].ratingArea
                            : null;
                    } catch (e) {
                        return null;
                    }
                };

                if (response.message.startsWith("single|")) {
                    return parseRatingAreaFromJson(response.message.split("|")[1]);
                }

                if (response.message.startsWith("multiple|")) {
                    return parseRatingAreaFromJson(response.message.split("|")[1]);
                }

                const pipeIndex = response.message.indexOf("|");
                if (pipeIndex > -1) {
                    return parseRatingAreaFromJson(response.message.substring(pipeIndex + 1));
                }

                return null;
            })
            .catch(() => null);
    };

    _loadWorksheetRatingArea = () => {
        return this._getWorksheetRatingArea()
            .then(ratingArea => {
                const normalizedRatingArea = ratingArea ? String(ratingArea) : "";
                this.setState({ worksheetRatingArea: normalizedRatingArea });
                return normalizedRatingArea;
            })
            .catch(() => {
                this.setState({ worksheetRatingArea: "" });
                return "";
            });
    };

    _loadWorksheetPossiblePlans = (carrierId, term = "") => {
        const {
            worksheetSelectedPlans,
            worksheetRenewalPlans,
            worksheetRenewalCarriers,
        } = this.state;

        if (
            !carrierId ||
            !Array.isArray(worksheetRenewalPlans) ||
            worksheetRenewalPlans.length === 0
        ) {
            this.setState({ worksheetPossiblePlans: [], worksheetPossiblePlansLoading: false });
            return;
        }

        const selectedCarrier = (worksheetRenewalCarriers || []).find(
            c => String(c.id || c.value) === String(carrierId),
        );
        const selectedCarrierName =
            selectedCarrier && selectedCarrier.name ? selectedCarrier.name.toLowerCase() : "";
        const normalizedTerm = (term || "").trim().toLowerCase();
        const filteredByCarrier = (worksheetRenewalPlans || []).filter(plan => {
            const planId = plan.id || plan.value;
            const planCarrierId = plan.carrierId || plan.currentMedicalCarrierId || plan.parentId;
            const planCarrierName = (
                plan.carrierName ||
                plan.carrier ||
                plan.type ||
                ""
            ).toLowerCase();
            const planLabel = (plan.displayName || plan.name || plan.label || "").toLowerCase();

            const matchesCarrierId = !!(
                planCarrierId && planCarrierId.toString() === carrierId.toString()
            );
            const matchesCarrierName = !!(
                planCarrierName &&
                selectedCarrierName &&
                planCarrierName === selectedCarrierName
            );
            const matchesCarrierInLabel = !!(
                selectedCarrierName && planCarrierName.indexOf(selectedCarrierName) > -1
            );
            const matchesFilter = !normalizedTerm || planLabel.indexOf(normalizedTerm) > -1;

            return (
                !!planId &&
                (matchesCarrierId || matchesCarrierName || matchesCarrierInLabel) &&
                matchesFilter
            );
        });

        this.setState({
            worksheetPossiblePlans: filteredByCarrier.filter(plan => {
                const planId = plan.id || plan.value;
                return !worksheetSelectedPlans.some(
                    selectedPlan =>
                        String(selectedPlan.id || selectedPlan.value) === String(planId),
                );
            }),
            worksheetPossiblePlansLoading: false,
        });
    };

    _handleWorksheetFrequencyChange = value => {
        this.setState({ worksheetFrequency: value });
    };

    _handleWorksheetBaseCarrierChange = value => {
        this.setState({
            worksheetBaseCarrier: value,
            worksheetBasePlan: "",
            worksheetBasePlanName: "",
        });
    };

    _handleWorksheetHasBasePlanChange = e => {
        const checked = e.target.checked;

        this.setState({
            worksheetHasBasePlan: checked,
            worksheetBaseCarrier: checked ? this.state.worksheetBaseCarrier : "",
            worksheetBasePlan: checked ? this.state.worksheetBasePlan : "",
            worksheetBasePlanName: checked ? this.state.worksheetBasePlanName : "",
        });
    };

    _handleWorksheetBasePlanChange = item => {
        this.setState({
            worksheetBasePlan: item && item.value ? item.value : "",
            worksheetBasePlanName: item && item.label ? item.label : "",
        });
    };

    _handleWorksheetBasePlanTextChange = value => {
        if (value === "") {
            this.setState({
                worksheetBasePlan: "",
                worksheetBasePlanName: "",
            });
        }
    };

    _searchWorksheetBasePlans = term => {
        const {
            worksheetBaseCarrier,
            worksheetRenewalCarriers,
            worksheetRenewalPlans,
        } = this.state;

        if (!Array.isArray(worksheetRenewalPlans) || worksheetRenewalPlans.length === 0) {
            return Promise.resolve([]);
        }

        const normalizedTerm = (term || "").trim().toLowerCase();

        if (!worksheetBaseCarrier) {
            return Promise.resolve(
                (worksheetRenewalPlans || []).filter(plan => {
                    if (!normalizedTerm) {
                        return true;
                    }
                    const label = (plan.displayName || plan.name || plan.label || "").toLowerCase();
                    return label.indexOf(normalizedTerm) > -1;
                }),
            );
        }

        const selectedCarrier = (worksheetRenewalCarriers || []).find(
            c => String(c.id || c.value) === String(worksheetBaseCarrier),
        );
        const selectedCarrierName =
            selectedCarrier && selectedCarrier.name ? selectedCarrier.name.toLowerCase() : "";

        return Promise.resolve(
            (worksheetRenewalPlans || []).filter(plan => {
                const carrierId = plan.carrierId || plan.currentMedicalCarrierId || plan.parentId;
                const carrierName = (
                    plan.carrierName ||
                    plan.carrier ||
                    plan.type ||
                    ""
                ).toLowerCase();
                const label = (plan.displayName || plan.name || plan.label || "").toLowerCase();

                const matchesCarrierId = !!(
                    carrierId && carrierId.toString() === worksheetBaseCarrier.toString()
                );
                const matchesCarrierName = !!(
                    carrierName &&
                    selectedCarrierName &&
                    carrierName === selectedCarrierName
                );
                const matchesCarrierInLabel = !!(
                    selectedCarrierName && carrierName.indexOf(selectedCarrierName) > -1
                );
                const matchesFilter = !normalizedTerm || label.indexOf(normalizedTerm) > -1;

                return (
                    (matchesCarrierId || matchesCarrierName || matchesCarrierInLabel) &&
                    matchesFilter
                );
            }),
        );
    };

    _handleWorksheetContributionToggle = () => {
        this.setState(prevState => ({
            worksheetContributionIsPercent: !prevState.worksheetContributionIsPercent,
        }));
    };

    _getSelectedWorksheetCensusIds = () => {
        const { census, worksheetSelectedRows } = this.state;
        const selectedSequenceNumbers = Object.keys(worksheetSelectedRows || {}).filter(
            key => !!worksheetSelectedRows[key],
        );

        if (selectedSequenceNumbers.length === 0) {
            return [];
        }

        const flatRows = (Array.isArray(census) ? census : []).reduce((rows, member) => {
            rows.push(member);
            if (Array.isArray(member.dependents) && member.dependents.length > 0) {
                rows.push(...member.dependents);
            }
            return rows;
        }, []);

        return selectedSequenceNumbers
            .map(sequenceNumber =>
                flatRows.find(
                    row => String(row.sequenceNumber || "") === String(sequenceNumber || ""),
                ),
            )
            .map(row =>
                Number((row && (row.id || row.censusId || row.censusID || row.memberId)) || 0),
            )
            .filter(id => Number.isInteger(id) && id > 0);
    };

    _submitNewHireWorksheet = () => {
        const {
            employer,
            worksheetSelectedPlans,
            worksheetHasBasePlan,
            worksheetBasePlan,
            worksheetEeContribution,
            worksheetDepContribution,
            worksheetFrequency,
            worksheetRenewalDate,
            worksheetEmployeeEnrollmentDate,
            worksheetApplyRolloverBalanceToDependents,
            worksheetContributionIsPercent,
        } = this.state;

        const censusIDs = this._getSelectedWorksheetCensusIds();
        if (censusIDs.length === 0) {
            toast.error("Select at least one census member for the worksheet.", { toastId: 12 });
            return;
        }

        const groupRenewalDate = this._formatWorksheetDateForApi(worksheetRenewalDate);
        const employeeNewHireDate = this._formatWorksheetDateForApi(
            worksheetEmployeeEnrollmentDate,
        );
        if (!groupRenewalDate || !employeeNewHireDate) {
            toast.error("Renewal Date and Employee Enrollment Date are required.", {
                toastId: 12,
            });
            return;
        }

        this.setState({ isSubmittingWorksheet: true });

        this._getWorksheetRatingArea()
            .then(ratingArea => {
                if (!ratingArea) {
                    throw new Error("Unable to determine rating area from group ZIP.");
                }

                const formatContribution = (amount, isPercent) => {
                    if (
                        amount === null ||
                        amount === undefined ||
                        amount === "" ||
                        Number(amount) === 0
                    ) {
                        return "";
                    }
                    if (isPercent) {
                        return amount + "%";
                    } else {
                        return "$" + amount;
                    }
                };
                const newHireWorksheet = {
                    medicalPlanIDs: (worksheetSelectedPlans || [])
                        .map(plan => plan.id || plan.value)
                        .filter(Boolean)
                        .join(","),
                    baseMedicalPlanID:
                        worksheetHasBasePlan && worksheetBasePlan
                            ? Number(worksheetBasePlan)
                            : null,
                    employeeContribution: formatContribution(
                        worksheetEeContribution,
                        worksheetContributionIsPercent,
                    ),
                    dependentContribution: formatContribution(
                        worksheetDepContribution,
                        worksheetContributionIsPercent,
                    ),
                    payrollCycleID: worksheetFrequency,
                    groupRenewalDate: groupRenewalDate,
                    applyRolloverBalanceToDependents: worksheetApplyRolloverBalanceToDependents,
                };

                const payload = {
                    NewHireWorksheet: JSON.stringify(newHireWorksheet),
                    censusIDs,
                    employerID: Number(this.props.match.params.id),
                    employerName: (employer && employer.name) || "",
                    ratingArea: Number(ratingArea),
                    groupRenewalDate,
                    employeeNewHireDate,
                };

                censusApi.newHireWorksheet(payload).then(response => {
                    //debugger;

                    if (response && response.startsWith("ERROR")) {
                        console.log("Output generation error: " + response);
                        if (response.indexOf("code 413") > -1) {
                            toast.error(
                                "There was an error encountered while generating your output.  Try reducing the number of 'Selected Plans' that you have saved with this proposal.",
                                { toastId: 13 },
                            );
                        } else {
                            toast.error(
                                "There was an error encountered while generating your output.",
                                { toastId: 13 },
                            );
                        }
                    }
                });
            })
            .then(() => {
                toast.success("New hire worksheet submitted.", { toastId: 11 });
                this.setState({ showModalAge: false, isSubmittingWorksheet: false });
            })
            .catch(err => {
                const responseData = err && err.response ? err.response.data : null;
                const errorMessage =
                    (responseData &&
                        (responseData.message || responseData.error || responseData)) ||
                    "Unable to submit new hire worksheet.";
                toast.error(errorMessage, { toastId: 12 });
                this.setState({ isSubmittingWorksheet: false });
            });
    };

    _handleLoadNewHireSettings = () => {
        const employerId = Number(this.props.match.params.id);
        const { worksheetRenewalDate } = this.state;

        censusApi
            .getNewHireSettings(employerId, worksheetRenewalDate)
            .then(response => {
                if (!response) return;

                const parseDateLocal = iso => {
                    if (!iso) return null;
                    const datePart = iso.split("T")[0];
                    const [year, month, day] = datePart.split("-").map(Number);
                    return new Date(year, month - 1, day);
                };

                const settings =
                    typeof response === "string"
                        ? JSON.parse(response)
                        : response.NewHireWorksheet
                        ? JSON.parse(response.NewHireWorksheet)
                        : response;

                const newState = {};

                if (settings.groupRenewalDate) {
                    newState.worksheetRenewalDate = parseDateLocal(settings.groupRenewalDate);
                }
                if (settings.employeeEnrollmentDate) {
                    newState.worksheetEmployeeEnrollmentDate = parseDateLocal(
                        settings.employeeEnrollmentDate,
                    );
                }
                if (settings.applyRolloverBalanceToDependents !== undefined) {
                    newState.worksheetApplyRolloverBalanceToDependents =
                        settings.applyRolloverBalanceToDependents;
                }
                if (settings.contributionIsPercent !== undefined) {
                    newState.worksheetContributionIsPercent = settings.contributionIsPercent;
                }
                if (settings.employeeContribution !== undefined) {
                    newState.worksheetEeContribution = settings.employeeContribution;
                }
                if (settings.dependentContribution !== undefined) {
                    newState.worksheetDepContribution = settings.dependentContribution;
                }
                if (settings.contributionIsPercent !== undefined) {
                    newState.worksheetContributionIsPercent = settings.contributionIsPercent;
                }
                if (settings.payrollCycleID !== undefined) {
                    newState.worksheetFrequency = settings.payrollCycleID;
                }

                const { worksheetRenewalDate: loadedRenewalDate, ...otherSettings } = newState;
                const selectedPlanIds = this._getWorksheetSelectedPlanIdsFromSettings(settings);
                const basePlanId = settings.baseMedicalPlanID || null;

                this.setState(otherSettings, () => {
                    if (loadedRenewalDate) {
                        this.setState(
                            {
                                worksheetRenewalDate: loadedRenewalDate,
                                worksheetCarrier: "",
                                worksheetSelectedPlans: [],
                                worksheetPossiblePlans: [],
                                worksheetPossiblePlansFilter: "",
                                worksheetRenewalCarriers: [],
                                worksheetRenewalPlans: [],
                            },
                            () => {
                                this._loadWorksheetRenewalAgeRatedPlans(loadedRenewalDate).then(
                                    () => {
                                        this._applyWorksheetSelectedPlansFromIds(
                                            selectedPlanIds,
                                            basePlanId,
                                        );
                                    },
                                );
                            },
                        );
                    } else {
                        this._applyWorksheetSelectedPlansFromIds(selectedPlanIds, basePlanId);
                    }
                });
                toast.success("New hire settings loaded.", { toastId: 14 });
            })
            .catch(err => {
                const responseData = err && err.response ? err.response.data : null;
                const errorMessage =
                    (responseData &&
                        (responseData.message || responseData.error || responseData)) ||
                    "Unable to load new hire settings.";
                toast.error(errorMessage, { toastId: 15 });
            });
    };

    _handleSaveNewHireSettings = () => {
        const {
            worksheetSelectedPlans,
            worksheetHasBasePlan,
            worksheetBasePlan,
            worksheetEeContribution,
            worksheetDepContribution,
            worksheetFrequency,
            worksheetRenewalDate,
            worksheetApplyRolloverBalanceToDependents,
            worksheetContributionIsPercent,
        } = this.state;

        const newHireWorksheet = {
            medicalPlanIDs: (worksheetSelectedPlans || [])
                .map(plan => plan.id || plan.value)
                .filter(Boolean)
                .join(","),
            baseMedicalPlanID:
                worksheetHasBasePlan && worksheetBasePlan ? Number(worksheetBasePlan) : null,
            employeeContribution: worksheetEeContribution,
            dependentContribution: worksheetDepContribution,
            payrollCycleID: worksheetFrequency,
            groupRenewalDate: worksheetRenewalDate,
            applyRolloverBalanceToDependents: worksheetApplyRolloverBalanceToDependents,
            contributionIsPercent: worksheetContributionIsPercent,
        };

        const payload = {
            NewHireWorksheet: JSON.stringify(newHireWorksheet),
            employerID: Number(this.props.match.params.id),
        };

        censusApi
            .saveNewHireSettings(payload)
            .then(() => {
                toast.success("New hire settings saved.", { toastId: 16 });
            })
            .catch(err => {
                const responseData = err && err.response ? err.response.data : null;
                const errorMessage =
                    (responseData &&
                        (responseData.message || responseData.error || responseData)) ||
                    "Unable to save new hire settings.";
                toast.error(errorMessage, { toastId: 17 });
            });
    };

    _isWorksheetLargeGroup = () => {
        const segmentSize = this.state.inputs[inputNames.segmentSize] || "";
        return segmentSize.indexOf("100") > -1;
    };

    _getStateFromZip = zipcode => {
        let st;
        if (zipcode >= 35000 && zipcode <= 36999) {
            st = "AL";
        } else if (zipcode >= 99500 && zipcode <= 99999) {
            st = "AK";
        } else if (zipcode >= 85000 && zipcode <= 86999) {
            st = "AZ";
        } else if (zipcode >= 71600 && zipcode <= 72999) {
            st = "AR";
        } else if (zipcode >= 90000 && zipcode <= 96699) {
            st = "CA";
        } else if (zipcode >= 80000 && zipcode <= 81999) {
            st = "CO";
        } else if ((zipcode >= 6000 && zipcode <= 6389) || (zipcode >= 6391 && zipcode <= 6999)) {
            st = "CT";
        } else if (zipcode >= 19700 && zipcode <= 19999) {
            st = "DE";
        } else if (zipcode >= 32000 && zipcode <= 34999) {
            st = "FL";
        } else if (
            (zipcode >= 30000 && zipcode <= 31999) ||
            (zipcode >= 39800 && zipcode <= 39999)
        ) {
            st = "GA";
        } else if (zipcode >= 96700 && zipcode <= 96999) {
            st = "HI";
        } else if (zipcode >= 83200 && zipcode <= 83999) {
            st = "ID";
        } else if (zipcode >= 60000 && zipcode <= 62999) {
            st = "IL";
        } else if (zipcode >= 46000 && zipcode <= 47999) {
            st = "IN";
        } else if (zipcode >= 50000 && zipcode <= 52999) {
            st = "IA";
        } else if (zipcode >= 66000 && zipcode <= 67999) {
            st = "KS";
        } else if (zipcode >= 40000 && zipcode <= 42999) {
            st = "KY";
        } else if (zipcode >= 70000 && zipcode <= 71599) {
            st = "LA";
        } else if (zipcode >= 3900 && zipcode <= 4999) {
            st = "ME";
        } else if (zipcode >= 20600 && zipcode <= 21999) {
            st = "MD";
        } else if ((zipcode >= 1000 && zipcode <= 2799) || zipcode === 5501 || zipcode === 5544) {
            st = "MA";
        } else if (zipcode >= 48000 && zipcode <= 49999) {
            st = "MI";
        } else if (zipcode >= 55000 && zipcode <= 56899) {
            st = "MN";
        } else if (zipcode >= 38600 && zipcode <= 39999) {
            st = "MS";
        } else if (zipcode >= 63000 && zipcode <= 65999) {
            st = "MO";
        } else if (zipcode >= 59000 && zipcode <= 59999) {
            st = "MT";
        } else if (zipcode >= 27000 && zipcode <= 28999) {
            st = "NC";
        } else if (zipcode >= 58000 && zipcode <= 58999) {
            st = "ND";
        } else if (zipcode >= 68000 && zipcode <= 69999) {
            st = "NE";
        } else if (zipcode >= 88900 && zipcode <= 89999) {
            st = "NV";
        } else if (zipcode >= 3000 && zipcode <= 3899) {
            st = "NH";
        } else if (zipcode >= 7000 && zipcode <= 8999) {
            st = "NJ";
        } else if (zipcode >= 87000 && zipcode <= 88499) {
            st = "NM";
        } else if (
            (zipcode >= 10000 && zipcode <= 14999) ||
            zipcode === 6390 ||
            zipcode === 501 ||
            zipcode === 544
        ) {
            st = "NY";
        } else if (zipcode >= 43000 && zipcode <= 45999) {
            st = "OH";
        } else if (
            (zipcode >= 73000 && zipcode <= 73199) ||
            (zipcode >= 73400 && zipcode <= 74999)
        ) {
            st = "OK";
        } else if (zipcode >= 97000 && zipcode <= 97999) {
            st = "OR";
        } else if (zipcode >= 15000 && zipcode <= 19699) {
            st = "PA";
        } else if (zipcode >= 300 && zipcode <= 999) {
            st = "PR";
        } else if (zipcode >= 2800 && zipcode <= 2999) {
            st = "RI";
        } else if (zipcode >= 29000 && zipcode <= 29999) {
            st = "SC";
        } else if (zipcode >= 57000 && zipcode <= 57999) {
            st = "SD";
        } else if (zipcode >= 37000 && zipcode <= 38599) {
            st = "TN";
        } else if (
            (zipcode >= 75000 && zipcode <= 79999) ||
            (zipcode >= 73301 && zipcode <= 73399) ||
            (zipcode >= 88500 && zipcode <= 88599)
        ) {
            st = "TX";
        } else if (zipcode >= 84000 && zipcode <= 84999) {
            st = "UT";
        } else if (zipcode >= 5000 && zipcode <= 5999) {
            st = "VT";
        } else if (
            (zipcode >= 20100 && zipcode <= 20199) ||
            (zipcode >= 22000 && zipcode <= 24699) ||
            zipcode === 20598
        ) {
            st = "VA";
        } else if (
            (zipcode >= 20000 && zipcode <= 20099) ||
            (zipcode >= 20200 && zipcode <= 20599) ||
            (zipcode >= 56900 && zipcode <= 56999)
        ) {
            st = "DC";
        } else if (zipcode >= 98000 && zipcode <= 99499) {
            st = "WA";
        } else if (zipcode >= 24700 && zipcode <= 26999) {
            st = "WV";
        } else if (zipcode >= 53000 && zipcode <= 54999) {
            st = "WI";
        } else if (zipcode >= 82000 && zipcode <= 83199) {
            st = "WY";
        }

        return st;
    };

    _getWorksheetCarrierOptions = () => {
        const { worksheetRenewalCarriers } = this.state;
        return Array.isArray(worksheetRenewalCarriers) ? worksheetRenewalCarriers : [];
    };

    _changeCarrier = item => {
        this.setState(
            prevState => {
                return {
                    selectedCarrier: item,
                    selectedPlanType: "",
                    selectedFundingType: "",
                    //selectedRatingArea: "",
                    allChecked: false,
                    showModalAge: false,
                    showModalSBS: false,
                    inputs: {
                        ...prevState.inputs,
                        [inputNames.baseMedicalPlanName]: "",
                    },
                };
            },
            () => {
                // this._getPlans();
            },
        );
    };

    _renderNotes = () => {
        return (
            <div className={css(styles.tabContent)}>
                <div className={css(styles.row)}>
                    <table className={css(styles.table)}>
                        <thead>
                            <tr>
                                {/*<td className={css(styles.tableHeader)}>Last Updated</td>*/}
                                <td className={css(styles.tableHeader)}>Date Created</td>
                                <td className={css(styles.tableHeader)}>Written By</td>
                                <td className={css(styles.tableHeader)}>Note</td>
                                {/*<td className={css(styles.tableHeader)}>Edit</td>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.notes.map(n => {
                                return (
                                    <tr key={n.id}>
                                        {/*
                                        <td className={css(styles.tableRow)}>
                                            {n.modifyDate &&
                                                <Moment format="MM/DD/YYYY">
                                                    {n.modifyDate}
                                                </Moment>   
                                            }
                                        </td>
                                        */}
                                        <td className={css(styles.tableRow)}>
                                            <Moment format="MM/DD/YYYY">{n.createDate}</Moment>
                                        </td>
                                        <td className={css(styles.tableRow)}>{n.writtenBy}</td>
                                        <td className={css(styles.tableRow)}>{n.note}</td>
                                        {/*<
                                        <td className={css(styles.tableRow)}>
                                            <img src={editIcon} alt="edit" className={css(styles.icon)} />
                                        </td>
                                    */}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    _renderHistory = () => {
        const { employer } = this.state;

        const currentMedicalPlans = [];
        if (employer.currentMedicalPlansFull) {
            const splitPlans = employer.currentMedicalPlansFull.split("|$$|");
            if (splitPlans.length > 0) {
                splitPlans.forEach(plan => {
                    const splitPlan = plan.split("|**|");
                    if (splitPlan.length === 11) {
                        const planMap = {
                            id: splitPlan[0],
                            year: splitPlan[1],
                            carrier: splitPlan[2],
                            displayName: splitPlan[3],
                            deductible: splitPlan[4],
                            coinsurance: splitPlan[5],
                            oop: splitPlan[6],
                            ee: splitPlan[7],
                            es: splitPlan[8],
                            ec: splitPlan[9],
                            ef: splitPlan[10],
                        };
                        currentMedicalPlans.push(planMap);
                    }
                });
            }
        }
        //list
        return (
            <div className={css(styles.tabContent)}>
                <div className={css(styles.row)}>
                    <table className={css(styles.table)}>
                        <thead>
                            <tr>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    Year
                                </td>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    Carrier
                                </td>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    Plan
                                </td>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    Ded
                                </td>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    Coins
                                </td>
                                <td className={css(styles.tableHeader)} rowSpan={2}>
                                    OOP
                                </td>
                                <td className={css(styles.tableHeader)} colSpan={4}>
                                    Tier Rates
                                </td>
                            </tr>
                            <tr>
                                <td className={css(styles.tableHeader)}>EE</td>
                                <td className={css(styles.tableHeader)}>ES</td>
                                <td className={css(styles.tableHeader)}>EC</td>
                                <td className={css(styles.tableHeader)}>EF</td>
                            </tr>
                        </thead>
                        <tbody>
                            {currentMedicalPlans && currentMedicalPlans.length > 0 ? (
                                currentMedicalPlans.map(plan => {
                                    return (
                                        <tr key={plan.id}>
                                            <td className={css(styles.tableRow)}>{plan.year}</td>
                                            <td className={css(styles.tableRow)}>{plan.carrier}</td>
                                            <td className={css(styles.tableRow)}>
                                                {plan.displayName}
                                            </td>
                                            <td className={css(styles.tableRow)}>
                                                {plan.deductible}
                                            </td>
                                            <td className={css(styles.tableRow)}>
                                                {plan.coinsurance}
                                            </td>
                                            <td className={css(styles.tableRow)}>{plan.oop}</td>
                                            <td className={css(styles.tableRow)}>{plan.ee}</td>
                                            <td className={css(styles.tableRow)}>{plan.es}</td>
                                            <td className={css(styles.tableRow)}>{plan.ec}</td>
                                            <td className={css(styles.tableRow)}>{plan.ef}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td className={css(styles.tableRow)} colSpan={10}>
                                        No Current Plans Specified.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    _hasGeneralInfoCounty = () => {
        const { employer } = this.state;
        const hasValue = value =>
            value !== null && value !== undefined && value.toString().trim().length > 0;
        const employerAddress =
            employer && employer.employerAddress ? employer.employerAddress : {};

        return (
            hasValue(employer && employer.countyId) ||
            hasValue(employer && employer.county) ||
            hasValue(employer && employer.countyName) ||
            hasValue(employerAddress.countyId) ||
            hasValue(employerAddress.county) ||
            hasValue(employerAddress.countyName)
        );
    };

    render() {
        const { me } = this.props;
        const {
            //currentTab,
            employer,
            quotes,
            years,
            selectedYear,
            selectedQuote,
            census,
            censusEditMode,
            employerLoaded,
            //selectedCarrier,
            //isSubmittingProposal,
            uniqueIds,
            showNewNoteModal,
            showUploadCensusModal,
            censusUpload,
            isSubmittingCensus,
            showModalAge,
            worksheetRenewalDate,
            worksheetEmployeeEnrollmentDate,
            worksheetRatingArea,
            worksheetCarrier,
            worksheetFrequency,
            worksheetApplyRolloverBalanceToDependents,
            worksheetBaseCarrier,
            worksheetBasePlanName,
            worksheetHasBasePlan,
            worksheetContributionIsPercent,
            worksheetEeContribution,
            worksheetDepContribution,
            worksheetSelectedRows,
            worksheetPossiblePlans,
            worksheetPossiblePlansFilter,
            showWorksheetPossiblePlansFilter,
            worksheetSelectedPlans,
            worksheetPossiblePlansLoading,
            isSubmittingWorksheet,
        } = this.state;

        if (!employerLoaded) {
            return (
                <div className={css(styles.content)}>
                    <div className={css(styles.contentSection)}>
                        <Spinner aStyles={styles.loadingSpinner} text="Loading Group..." />
                    </div>
                </div>
            );
        }

        //list of available census records from Custom AND from Quotes
        const censuses = [];
        if (uniqueIds && uniqueIds.length > 0) {
            for (let i = 0; i < uniqueIds.length; i++) {
                // Normalize GUID to lowercase for case-insensitive matching
                const censusId = (
                    uniqueIds[i].guid ||
                    uniqueIds[i].uniqueId ||
                    uniqueIds[i].id ||
                    ""
                )
                    .toString()
                    .toLowerCase();
                if (censusId) {
                    censuses.push({
                        label: "Group Census, created on " + uniqueIds[i].createDate,
                        id: censusId,
                    });
                }
            }
        }
        if (quotes && quotes.length > 0) {
            for (let i = 0; i < quotes.length; i++) {
                censuses.push({
                    label:
                        "Quote " +
                        quotes[i].quoteNumber +
                        " w/ " +
                        quotes[i].effectiveDateString +
                        " eff, created on " +
                        quotes[i].createDateString,
                    id: quotes[i].id.toString().toLowerCase(),
                });
            }
        }

        const hasWorksheetSelection = (Array.isArray(census) ? census : []).some(
            c =>
                !!worksheetSelectedRows[c.sequenceNumber] ||
                (c.dependents || []).some(d => !!worksheetSelectedRows[d.sequenceNumber]),
        );
        const normalizedWorksheetPossiblePlansFilter = (worksheetPossiblePlansFilter || "")
            .trim()
            .toLowerCase();
        const filteredWorksheetPossiblePlans = (worksheetPossiblePlans || []).filter(plan => {
            if (!normalizedWorksheetPossiblePlansFilter) {
                return true;
            }

            const planText = (plan.displayName || plan.name || plan.label || "").toLowerCase();
            return planText.indexOf(normalizedWorksheetPossiblePlansFilter) > -1;
        });
        const hasWorksheetRequiredDates =
            !!worksheetRenewalDate && !!worksheetEmployeeEnrollmentDate;
        const canSubmitWorksheet =
            hasWorksheetRequiredDates && worksheetSelectedPlans.length > 0 && !!worksheetFrequency;
        const hasGeneralInfoCounty = this._hasGeneralInfoCounty();

        return (
            <div className={css(styles.content)}>
                <ToastContainer position="top-center" autoClose={3500} />
                <div className={css(styles.contentSection)}>
                    <div className={css(styles.titleSection)}>
                        {me.ratingEngineQuotePermission &&
                            (this.state.currentTab === "" ||
                                this.state.currentTab === "General Info") && (
                                <AddButton
                                    aStyles={styles.addButton}
                                    onClick={this._addQuote}
                                    label="Quote This Group"
                                />
                            )}
                        {this.state.currentTab === "Notes" && (
                            <AddButton
                                aStyles={styles.addButton}
                                onClick={this._addNote}
                                label="Add New Note"
                            />
                        )}
                        <PageTitle>
                            Group: {employer.name} {employer.deleted ? "(DELETED)" : ""}
                        </PageTitle>
                    </div>
                </div>
                <div className={css(styles.groupDetails)}>
                    <Tabs
                        history={this.props.history}
                        backUrl={routeHelpers.groups()}
                        tabChanged={this._handleTabChanged}
                    >
                        <div label={strings.generalInfoTabLabel}>{this._renderGeneralInfo()}</div>
                        <div label={strings.quotesTabLabel}>
                            <div className={css(styles.tabContentHeader)}>
                                <div className={css(styles.quotesByYearHeader)}>
                                    <div className={css(styles.quotesByYearText)}>
                                        {strings.quotesByYearText}
                                    </div>
                                    <div className={css(styles.quotesByYearDropdown)}>
                                        <SmallDropdown
                                            aStyles={styles.dropdown}
                                            options={years.map(year => ({
                                                label: year,
                                                value: year,
                                            }))}
                                            value={selectedYear}
                                            placeholder={""}
                                            onChange={this._changeYearQuotes}
                                            hideLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            {this._renderQuotes()}
                        </div>
                        <div label={strings.groupHistoryTabLabel}>
                            <div className={css(styles.tabContentHeader)}>
                                <div className={css(styles.tabContentHeaderText)}>
                                    {strings.groupHistoryTabLabel}
                                </div>
                            </div>
                            {this._renderHistory()}
                        </div>
                        <div label={strings.censusTabLabel}>
                            <div className={css(styles.tabContentHeader)}>
                                <div className={css(styles.censusButtonsHeader)}>
                                    {(me.isSysAdmin || me.isOfficeAdmin || me.isBroker) &&
                                        !employer.deleted &&
                                        me.ratingEngineQuotePermission &&
                                        !isSubmittingCensus && (
                                            <AddButton
                                                aStyles={styles.addButton}
                                                onClick={this._openCensusModal}
                                                label="Upload New Census"
                                                showAsBlue={true}
                                            />
                                        )}
                                    {(me.isSysAdmin || me.isOfficeAdmin || me.isBroker) &&
                                        !employer.deleted &&
                                        me.ratingEngineQuotePermission &&
                                        selectedQuote &&
                                        !isSubmittingCensus &&
                                        !censusEditMode && (
                                            <AddButton
                                                aStyles={styles.addButton}
                                                onClick={this._copyCensus}
                                                label="Edit This Census"
                                            />
                                        )}
                                    {(me.isSysAdmin || me.isOfficeAdmin || me.isBroker) &&
                                        !employer.deleted &&
                                        me.ratingEngineQuotePermission &&
                                        selectedQuote &&
                                        selectedQuote.length === 36 &&
                                        !isSubmittingCensus &&
                                        censusEditMode && (
                                            <AddButton
                                                aStyles={styles.addButton}
                                                onClick={this._saveCensus}
                                                label="Save This Census"
                                            />
                                        )}
                                    {isSubmittingCensus && (
                                        <Spinner
                                            aStyles={styles.addButtonSpinner}
                                            text="Loading Census..."
                                        />
                                    )}
                                </div>
                                <div className={css(styles.quotesByYearHeader)}>
                                    <div className={css(styles.quotesByYearText)}>
                                        {strings.censusInformationText}
                                    </div>
                                    <div className={css(styles.censusDropdown)}>
                                        <SmallDropdown
                                            aStyles={styles.dropdown}
                                            options={censuses.map(cs => ({
                                                label: cs.label,
                                                value: cs.id,
                                            }))}
                                            value={selectedQuote}
                                            placeholder={"Choose a Census"}
                                            onChange={this._changeCensus}
                                            hideLabel={true}
                                        />
                                    </div>
                                </div>

                                {!censusEditMode && hasWorksheetSelection && hasGeneralInfoCounty && (
                                    <div className={css(styles.columnFilterContainer2)}>
                                        <div className={css(styles.resetButtonHolder)}>
                                            <AddButton
                                                aStyles={styles.worksheetButton}
                                                onClick={this._handleShowModalAge}
                                                label="New Hire Worksheet"
                                                showAsBlue={true}
                                            />
                                        </div>
                                    </div>
                                )}
                                {!censusEditMode && !hasGeneralInfoCounty && (
                                    <div className={css(styles.columnFilterContainer2)}>
                                        <div className={css(styles.countyRequiredMessage)}>
                                            County needs to be set on General Info Tab
                                        </div>
                                    </div>
                                )}
                            </div>
                            {this._renderCensus()}
                        </div>
                        <div label={strings.notesTabLabel}>
                            <div className={css(styles.tabContentHeader)}>
                                <div className={css(styles.tabContentHeaderText)}>
                                    {strings.notesTabLabel}
                                </div>
                            </div>
                            {this._renderNotes()}
                        </div>
                    </Tabs>
                </div>
                <Modal show={showNewNoteModal} header="Add Note">
                    <div className={css(styles.modalContent)}>
                        <div className={css(styles.modalInstructions)}>Type your note here:</div>
                        <TextArea
                            name={inputNames.note}
                            onChange={this._handleTextChange}
                            placeholder="Enter text..."
                            required={true}
                            validationMessage={this.state.errors[inputNames.note]}
                            value={this.state.inputs[inputNames.note]}
                        />
                    </div>
                    <div className={css(styles.modalButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Cancel"
                            invertColor={true}
                            type="button"
                            onClick={() => this.setState({ showNewNoteModal: false })}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Save"
                            onClick={this._saveNote}
                            type="button"
                            isLoading={this.state.isSaving}
                        />
                    </div>
                </Modal>
                {/* Upload New Census */}
                <Modal show={showUploadCensusModal} header="Upload Census">
                    <div className={css(styles.modalContent)}>
                        <div
                            className={css(
                                styles.censusButton,
                                styles.loadCensusButton,
                                censusUpload !== null ? styles.censusFileSelected : null,
                            )}
                        >
                            {censusUpload === null ? (
                                <Dropzone onDrop={this._censusDropped}>
                                    {({ getRootProps, getInputProps }) => (
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className={css(styles.censusButtonText)}>
                                                Drop your Census file here or{" "}
                                                <FileBrowser
                                                    onSelect={this._censusFileSelected}
                                                    disableClick={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Dropzone>
                            ) : (
                                <React.Fragment>
                                    <div className={css(styles.censusButtonText)}>Your File:</div>
                                    <div className={css(styles.censusSelectedButtonText)}>
                                        {censusUpload.name}
                                    </div>
                                    <CancelIcon
                                        className={css(styles.clearCensusButton)}
                                        onClick={this._cancelCensusClicked}
                                    />
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div className={css(styles.modalButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Cancel"
                            invertColor={true}
                            type="button"
                            onClick={() => this.setState({ showUploadCensusModal: false })}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Upload"
                            onClick={this._uploadCensus}
                            type="button"
                            disabled={!censusUpload}
                            isLoading={isSubmittingCensus}
                        />
                    </div>
                </Modal>

                <Modal
                    show={showModalAge}
                    taller={true}
                    header="New Hire Worksheet"
                    aStyles={styles.worksheetModalContainer}
                    contentContainerStyles={styles.worksheetModalBody}
                >
                    <div className={css(styles.worksheetModalContent)}>
                        <div>
                            <h2>
                                Group: {employer.name} {this.state.stateText} -{" "}
                                {this.state.selectedCounty ||
                                    employer.county ||
                                    employer.countyName}{" "}
                                Rating Area {worksheetRatingArea || "-"}
                            </h2>
                        </div>

                        <div className={css(styles.worksheetFieldsRow)}>
                            <div className={css(styles.worksheetField)}>
                                <div className={css(styles.ItemTitle)}>
                                    Current Effective Date{" "}
                                    <span className={css(styles.worksheetRequiredLabel)}>
                                        (Required)
                                    </span>
                                </div>
                                <DatePicker
                                    name="worksheetRenewalDate"
                                    onChange={this._handleWorksheetDateChange}
                                    placeholder="Enter Current Effective Date"
                                    hideLabel={true}
                                    value={worksheetRenewalDate}
                                />
                            </div>
                            <div className={css(styles.worksheetField)}>
                                <div className={css(styles.ItemTitle)}>
                                    Employee Enrollment Date{" "}
                                    <span className={css(styles.worksheetRequiredLabel)}>
                                        (Required)
                                    </span>
                                </div>
                                <DatePicker2
                                    name="worksheetEmployeeEnrollmentDate"
                                    onChange={this._handleWorksheetDateChange}
                                    placeholder="Enter Employee Enrollment Date"
                                    hideLabel={true}
                                    value={worksheetEmployeeEnrollmentDate}
                                />
                            </div>
                        </div>

                        {hasWorksheetRequiredDates && (
                            <React.Fragment>
                                <h1>Select Plans</h1>
                                <div className={css(styles.worksheetControlRow)}>
                                    <Dropdown
                                        options={this._getWorksheetCarrierOptions().map(n => ({
                                            label: n.name,
                                            value: n.id || n.value,
                                        }))}
                                        value={worksheetCarrier}
                                        placeholder="Carrier"
                                        onChange={this._handleWorksheetCarrierChange}
                                        hideLabel={true}
                                    />
                                </div>

                                <div className={css(styles.worksheetPlansRow)}>
                                    <div className={css(styles.worksheetListColumn)}>
                                        <div
                                            className={css(
                                                styles.worksheetListHeader,
                                                styles.worksheetListHeaderWithIcon,
                                            )}
                                        >
                                            <span>List of Possible Plans</span>
                                            <button
                                                type="button"
                                                className={css(
                                                    styles.worksheetListHeaderIconButton,
                                                )}
                                                onClick={this._toggleWorksheetPossiblePlansFilter}
                                                aria-label={
                                                    showWorksheetPossiblePlansFilter
                                                        ? "Hide possible plans filter"
                                                        : "Show possible plans filter"
                                                }
                                            >
                                                <img
                                                    src={searchIcon}
                                                    alt="search"
                                                    className={css(styles.worksheetListHeaderIcon)}
                                                />
                                            </button>
                                        </div>
                                        {showWorksheetPossiblePlansFilter && (
                                            <div className={css(styles.worksheetControlRow)}>
                                                <TextInput
                                                    name="worksheetPossiblePlansFilter"
                                                    aStyles={styles.worksheetListFilterInput}
                                                    value={worksheetPossiblePlansFilter}
                                                    onChange={
                                                        this
                                                            ._handleWorksheetPossiblePlansFilterChange
                                                    }
                                                    placeholder="Filter possible plans"
                                                    hideLabel={true}
                                                />
                                            </div>
                                        )}
                                        <div className={css(styles.worksheetListBody)}>
                                            {worksheetPossiblePlansLoading && (
                                                <div>Loading plans...</div>
                                            )}
                                            {!worksheetPossiblePlansLoading &&
                                                filteredWorksheetPossiblePlans.map(plan => (
                                                    <div
                                                        key={plan.id || plan.value}
                                                        className={css(styles.worksheetPlanItem)}
                                                    >
                                                        <div
                                                            className={css(
                                                                styles.worksheetPlanItemName,
                                                            )}
                                                        >
                                                            {plan.displayName ||
                                                                plan.name ||
                                                                plan.label}
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={css(
                                                                styles.worksheetPlanMoveButton,
                                                            )}
                                                            onClick={() =>
                                                                this._handleWorksheetSelectPlan(
                                                                    plan.id || plan.value,
                                                                )
                                                            }
                                                            aria-label={`Select ${plan.displayName ||
                                                                plan.name ||
                                                                plan.label}`}
                                                        >
                                                            <img alt="add" src={plusIcon} />
                                                        </button>
                                                    </div>
                                                ))}
                                            {!worksheetPossiblePlansLoading &&
                                                filteredWorksheetPossiblePlans.length === 0 && (
                                                    <div
                                                        className={css(
                                                            styles.worksheetListEmptyText,
                                                        )}
                                                    >
                                                        No plans available.
                                                    </div>
                                                )}
                                        </div>
                                    </div>

                                    <div className={css(styles.worksheetListColumn)}>
                                        <div className={css(styles.worksheetListHeader)}>
                                            List of Selected Plans
                                        </div>
                                        <div className={css(styles.worksheetListBody)}>
                                            {worksheetSelectedPlans.map(plan => (
                                                <div
                                                    key={plan.id || plan.value}
                                                    className={css(styles.worksheetPlanItem)}
                                                >
                                                    <div
                                                        className={css(
                                                            styles.worksheetPlanItemName,
                                                        )}
                                                    >
                                                        {plan.displayName ||
                                                            plan.name ||
                                                            plan.label}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className={css(
                                                            styles.worksheetPlanRemoveButton,
                                                        )}
                                                        onClick={() =>
                                                            this._handleWorksheetRemovePlan(
                                                                plan.id || plan.value,
                                                            )
                                                        }
                                                        aria-label={`Remove ${plan.displayName ||
                                                            plan.name ||
                                                            plan.label}`}
                                                    >
                                                        <GarbageIcon
                                                            className={css(
                                                                styles.worksheetPlanRemoveIcon,
                                                            )}
                                                        />
                                                    </button>
                                                </div>
                                            ))}
                                            {worksheetSelectedPlans.length === 0 && (
                                                <div className={css(styles.worksheetListEmptyText)}>
                                                    No selected plans.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <h1>Employer Contributions</h1>
                                <div className={css(styles.worksheetCheckboxRow)}>
                                    <Checkbox
                                        id="worksheetApplyRolloverBalanceToDependents"
                                        name="worksheetApplyRolloverBalanceToDependents"
                                        checked={worksheetApplyRolloverBalanceToDependents}
                                        onChange={this._handleWorksheetInputChange}
                                    />
                                    <label
                                        htmlFor="worksheetApplyRolloverBalanceToDependents"
                                        className={css(styles.worksheetCheckboxLabel)}
                                    >
                                        Apply Rollover Balance to Dependents
                                    </label>
                                </div>
                                <div className={css(styles.worksheetContributionRow)}>
                                    <div className={css(styles.worksheetContributionCol)}>
                                        <div className={css(styles.ItemTitle)}>Frequency</div>
                                        <Dropdown
                                            options={Object.keys(this.state.payrollCycles).map(
                                                id => ({
                                                    label: this.state.payrollCycles[id].name,
                                                    value: this.state.payrollCycles[id].id,
                                                }),
                                            )}
                                            value={worksheetFrequency}
                                            placeholder="Frequency"
                                            onChange={this._handleWorksheetFrequencyChange}
                                            extendUp={true}
                                            hideLabel={true}
                                        />
                                    </div>
                                    <div className={css(styles.worksheetContributionCol)}>
                                        <div className={css(styles.worksheetAmountHeaderRow)}>
                                            <div className={css(styles.ItemTitle)}>Amount</div>
                                            <div
                                                className={css(styles.worksheetAmountToggleInline)}
                                            >
                                                <div className={css(styles.worksheetSymbol)}>%</div>
                                                <Toggle
                                                    aStyles={styles.worksheetToggle}
                                                    checked={worksheetContributionIsPercent}
                                                    onChange={
                                                        this._handleWorksheetContributionToggle
                                                    }
                                                />
                                                <div className={css(styles.worksheetSymbol)}>$</div>
                                            </div>
                                        </div>
                                        <div className={css(styles.worksheetAmountControls)}>
                                            <div className={css(styles.worksheetAmountField)}>
                                                <TextInput
                                                    name="worksheetEeContribution"
                                                    onChange={this._handleWorksheetInputChange}
                                                    placeholder="EE"
                                                    value={worksheetEeContribution}
                                                    prependLabel={null}
                                                    appendLabel={
                                                        worksheetContributionIsPercent ? "%" : "$"
                                                    }
                                                />
                                            </div>
                                            <div className={css(styles.worksheetAmountField)}>
                                                <TextInput
                                                    name="worksheetDepContribution"
                                                    onChange={this._handleWorksheetInputChange}
                                                    placeholder="DEP"
                                                    value={worksheetDepContribution}
                                                    prependLabel={null}
                                                    appendLabel={
                                                        worksheetContributionIsPercent ? "%" : "$"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={css(styles.worksheetCheckboxRow)}>
                                    <Checkbox
                                        id="worksheetHasBasePlan"
                                        name="worksheetHasBasePlan"
                                        checked={worksheetHasBasePlan}
                                        onChange={this._handleWorksheetHasBasePlanChange}
                                    />
                                    <label
                                        htmlFor="worksheetHasBasePlan"
                                        className={css(styles.worksheetCheckboxLabel)}
                                    >
                                        Add A Base Plan
                                    </label>
                                </div>
                                {worksheetHasBasePlan && (
                                    <React.Fragment>
                                        <div className={css(styles.ItemTitle)}>Base Plan</div>
                                        <div className={css(styles.worksheetControlRow)}>
                                            <Dropdown
                                                options={this._getWorksheetCarrierOptions().map(
                                                    n => ({
                                                        label: n.name,
                                                        value: n.id || n.value,
                                                    }),
                                                )}
                                                value={worksheetBaseCarrier}
                                                placeholder="Base Carrier"
                                                onChange={this._handleWorksheetBaseCarrierChange}
                                                extendUp={true}
                                                hideLabel={true}
                                            />
                                        </div>
                                        <div className={css(styles.worksheetControlRow)}>
                                            <SearchInput
                                                key={`worksheet-base-plan-${worksheetBaseCarrier ||
                                                    "none"}`}
                                                search={this._searchWorksheetBasePlans}
                                                onItemSelected={this._handleWorksheetBasePlanChange}
                                                onTextChanged={
                                                    this._handleWorksheetBasePlanTextChange
                                                }
                                                placeholder={
                                                    worksheetBasePlanName
                                                        ? worksheetBasePlanName
                                                        : "Set Base Plan"
                                                }
                                                hideLabel={true}
                                                type={searchInputTypes.textNoIconShort}
                                                disabled={!worksheetBaseCarrier}
                                                value={worksheetBasePlanName}
                                                showResultsAbove={true}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                    <div className={css(styles.worksheetDisclaimerText)}>
                        Users must determine employee plan eligibility based on service area or home
                        state; availability varies by location.
                    </div>
                    <div className={css(styles.worksheetModalButtonRow)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Load Settings"
                            type="button"
                            onClick={this._handleLoadNewHireSettings}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Save Settings"
                            type="button"
                            onClick={this._handleSaveNewHireSettings}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Submit"
                            type="button"
                            onClick={this._submitNewHireWorksheet}
                            disabled={!canSubmitWorksheet}
                            isLoading={isSubmittingWorksheet}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Close"
                            invertColor={true}
                            type="button"
                            onClick={this._handleHideModalAge}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}
const mapDispatchToProps = state => ({
    me: state.session.me,
});

export default connect(mapDispatchToProps)(GroupDetailScreen);
